import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DialogService as DynamicDialogService } from 'primeng/dynamicdialog';
import { CardSetTransformationService, DialogResult, DialogService, CoreService, SpinnerService, DataService, SaveDataRequest, VerticalNavigationSettings, SaveFormEvent, FormNavigationService, ElementType, DspxBaseFormComponent, DocumentListFieldType, FormSummaryFieldType } from 'dspx-core';
import { bufferTime, filter, finalize, Subscription, take } from 'rxjs';
import { API_ENDPOINT_KEYS, API_ENDPOINTS } from 'src/app/constants/api-endpoints.constants';
import { APP_DATA_KEYS, ClaimTypes, FORM_IDENTIFIERS, NAV_TAB_NUMBERS, OPTION_SETS, PAGE_NUMBERS, POP_UP_CODES, QUESTION_CODES, SAVE_RESULT_STATUS, SECTION_CODES, SERVER_ERROR_POP_UP_CODES, EMPTY_GUID, VPTAS_AGE_CATEGORIES, VPTAS_AGE_THRESHOLDS, VPTAS_CLAIM_FOR_IDS, VPTAS_TRIP_TYPE_IDS, VptasCommonConstants, REFERENCE_DATA_IDS } from 'src/app/constants/app-data.constants';
import { ROUTE_CONSTANTS } from 'src/app/constants/route.constants';
import { TEMPLATES, VERSIONS } from 'src/app/constants/templates.constants';
import { AppDataService } from 'src/app/services/app-data.service';
import { ErrorService } from 'src/app/services/error.service';
import { ResponseParserService } from '../../services/response-parser.service';
import { AbstractControl, FormArray, FormGroup } from '@angular/forms';
import { BaseCardSetDetailWithHeaderComponent } from '../base-card-set-detail-with-header-component/base-card-set-detail-with-header-component';
import { DateUtilService } from 'src/app/services/date-util.service';
import { FormlyConfig } from '@ngx-formly/core';
import { Guid } from 'guid-typescript';
import { multiCheckboxAllRequiredValidator } from 'src/app/validators/multiCheckboxAllRequiredValidator.validator';
import * as _ from 'lodash';
import { CentrelinkCardCheckResponse } from 'src/app/interfaces/centrelink-card-check-response.interface';
import { VptasApplicationSaveDataRequest } from 'src/app/interfaces/vptas-application-save-data-request';
import { VptasDocumentListFieldType } from '../document-list/document-list.type';
import { CustomFormSummaryFieldType } from '../form-summary/formsummary.type';
import { VptasSpecialistSearchFormComponent } from '../vptas-specialist-search-form/vptas-specialist-search-form.component';

// TODO: Pending requirement finalization. Copied and adapted concession application code for demo
// and prototyping purposes. Actual implementation will be done once requirements are finalized.
@Component({
  selector: 'app-victorian-patient-transport-assistance-scheme-application',
  templateUrl: './victorian-patient-transport-assistance-scheme-application.component.html',
  styleUrls: ['./victorian-patient-transport-assistance-scheme-application.component.scss']
})
export class VictorianPatientTransportAssistanceSchemeApplication extends BaseCardSetDetailWithHeaderComponent implements OnInit, OnDestroy {

  fieldTypeReplacements =
    CardSetTransformationService.cardSetFieldTypeReplacements;
  formServiceEndpoint: string = API_ENDPOINT_KEYS.getFormConfig;
  verticalNavigationSettings: VerticalNavigationSettings = { enabled: true, sticky: true, pageLevel: true, type: 'horizontal-stepper' };
  formNavSubscription: Subscription;

  private _previousTab: number = 0;
  private _previousPage: number = 0;
  private _currentTab: number = 1;
  private _currentPage: number = 1;
  private _hasAppliedInitialApplicantStep: boolean = false;

  templateId: number = TEMPLATES.victorianPatientTransportAssistanceSchemeApplication;
  versionNo: number = VERSIONS.latest;
  model: any;
  editing: boolean = false;
  // primaryAddressIsManual: boolean = false;
  activeApplications: any;
  patientOptions: any[];
  protected id: string = '';
  protected saveEndpoint: string = '';
  protected activeDialog: string = '';
  isDraftApplication: boolean = true;
  treatmentDateValidationStatus: { [pageIndex: number]: boolean } = {};
  travelDateValidationStatus: { [key: string]: boolean } = {};
  private hideTransportSectionForRemount: { [pageIndex: number]: boolean } = {};
  private pendingClonePageSectionIndex: any = null;

  private readonly MAX_BLOCK_TREATMENT_ITEMS = 9999;
  private readonly MAX_TRANSPORT_MODE_ITEMS = 9999;

  constructor(protected router: Router,
    protected route: ActivatedRoute,
    protected dialogService: DialogService,
    protected dynamicDialogService: DynamicDialogService,
    protected appDataService: AppDataService,
    protected responseParserService: ResponseParserService,
    protected spinnerService: SpinnerService,
    protected errorService: ErrorService,
    protected dataService: DataService,
    private coreService: CoreService,
    private formNavigationService: FormNavigationService,
    private dateUtil: DateUtilService,
    private cdr: ChangeDetectorRef,
    private formlyConfig: FormlyConfig
  ) {
    super(router, appDataService, responseParserService);
    this.overrideSummaryAndDocumentListWithCustomComponents();
  }

  showTransportDateOfReturn(pageSectionIndex): boolean {
    const [pageIndex, sectionIndex] = this.getPageAndSectionIndex(pageSectionIndex);
    if (Number.isNaN(pageIndex) || Number.isNaN(sectionIndex)) { return false; }

    const formGroup = this.baseForm.form.controls.form as FormGroup;
    const pageArray: any = formGroup.get(`tabs.tab${NAV_TAB_NUMBERS.vptasApplication.travelAndAccommodation}.page${PAGE_NUMBERS.vptasApplicationForm.travelAndAccommodation}`);
    if (!pageArray?.controls || pageIndex < 0 || pageIndex >= pageArray.length) {
      return false;
    }

    const pageCtrl = pageArray.controls[pageIndex];
    const section = pageCtrl?.controls?.[SECTION_CODES.vptasApplicationForm.transportDetails];
    const idx = sectionIndex >= 0 ? sectionIndex : 0;
    const tripTypeCode = SECTION_CODES.vptasApplicationForm.transportDetailsTripType;
    const sameDayCode = SECTION_CODES.vptasApplicationForm.transportDetailsIsReturnOnSameDay;
    const endDateCode = SECTION_CODES.vptasApplicationForm.transportDetailsDateOfReturn;
    const startDateCode = SECTION_CODES.vptasApplicationForm.transportDetailsDateOfTravel;
    const tripTypeCtrl = section?.controls?.[idx]?.controls?.[tripTypeCode]
      || section?.controls?.[0]?.controls?.[tripTypeCode]
      || section?.controls?.[tripTypeCode];
    const sameDayCtrl = section?.controls?.[idx]?.controls?.[sameDayCode]
      || section?.controls?.[0]?.controls?.[sameDayCode]
      || section?.controls?.[sameDayCode];

    const tripType = (tripTypeCtrl?.value ?? '').toString().toLowerCase();
    const isReturn = [VPTAS_TRIP_TYPE_IDS.return, VPTAS_TRIP_TYPE_IDS.dropOff, VPTAS_TRIP_TYPE_IDS.pickUp].includes(tripType);
    const sameDayRaw = sameDayCtrl?.value;
    const isSameDay = (sameDayRaw === true) || (sameDayRaw?.toString?.().toLowerCase() === 'true');
    // Auto-sync end date to start date when same-day is selected
    if (isReturn && isSameDay) {
      const item = section?.controls?.[idx];
      const startCtrl = item?.controls?.[startDateCode];
      const endCtrl = item?.controls?.[endDateCode];
      const startVal = startCtrl?.value;
      const endVal = endCtrl?.value;
      if (startVal && startVal !== endVal) {
        endCtrl?.patchValue(startVal, { emitEvent: true });
      }
    }
    if (this.showTransportDetailsCloneButton(pageSectionIndex)) {
      const item = section?.controls?.[idx];
      const startCtrl = item?.controls?.[startDateCode];
      const endCtrl = item?.controls?.[endDateCode];
      const startVal = startCtrl?.value;
      const endVal = endCtrl?.value;
      if (startVal && startVal !== endVal && endCtrl?.value == null) {
        endCtrl?.patchValue(startVal, { emitEvent: true });
      }
    }
    return (isReturn || this.getIsBlockTreatement()) && !isSameDay;
  }

  showTransportReturnOnSameDay(pageSectionIndex): boolean {
    const [pageIndexStr, sectionIndexStr] = this.getPageAndSectionIndex(pageSectionIndex);
    const pageIndex = Number(pageIndexStr);
    const sectionIndex = Number(sectionIndexStr);
    if (Number.isNaN(pageIndex) || Number.isNaN(sectionIndex)) { return false; }

    const formGroup = this.baseForm.form.controls.form as FormGroup;
    const pageArray: any = formGroup.get(`tabs.tab${NAV_TAB_NUMBERS.vptasApplication.travelAndAccommodation}.page${PAGE_NUMBERS.vptasApplicationForm.travelAndAccommodation}`);
    if (!pageArray?.controls || pageIndex < 0 || pageIndex >= pageArray.length) {
      return false;
    }

    const pageCtrl = pageArray.controls[pageIndex];
    const section = pageCtrl?.controls?.[SECTION_CODES.vptasApplicationForm.transportDetails];
    const idx = sectionIndex >= 0 ? sectionIndex : 0;
    const tripTypeCode = SECTION_CODES.vptasApplicationForm.transportDetailsTripType;
    const tripTypeCtrl = section?.controls?.[idx]?.controls?.[tripTypeCode]
      || section?.controls?.[0]?.controls?.[tripTypeCode]
      || section?.controls?.[tripTypeCode];
    const tripType = (tripTypeCtrl?.value ?? '').toString().toLowerCase();
    const isReturn = [VPTAS_TRIP_TYPE_IDS.return, VPTAS_TRIP_TYPE_IDS.dropOff, VPTAS_TRIP_TYPE_IDS.pickUp].includes(tripType) || this.getIsBlockTreatement();
    return isReturn;
  }

  showTransportTypeOfTravel(pageSectionIndex): boolean {
    const [pageIndex, sectionIndex] = this.getPageAndSectionIndex(pageSectionIndex);;
    if (Number.isNaN(pageIndex) || Number.isNaN(sectionIndex)) { return false; }

    const formGroup = this.baseForm.form.controls.form as FormGroup;
    const pageArray: any = formGroup.get(`tabs.tab${NAV_TAB_NUMBERS.vptasApplication.travelAndAccommodation}.page${PAGE_NUMBERS.vptasApplicationForm.travelAndAccommodation}`);
    if (!pageArray?.controls || pageIndex < 0 || pageIndex >= pageArray.length) {
      return false;
    }

    const pageCtrl = pageArray.controls[pageIndex];
    const section = pageCtrl?.controls?.[SECTION_CODES.vptasApplicationForm.transportDetails];
    const idx = sectionIndex >= 0 ? sectionIndex : 0;
    const typeCode = SECTION_CODES.vptasApplicationForm.transportDetailsTransportType;
    const transportTypeCtrl = section?.controls?.[idx]?.controls?.[typeCode]
      || section?.controls?.[0]?.controls?.[typeCode]
      || section?.controls?.[typeCode];
    const transportType = (transportTypeCtrl?.value ?? '').toString().toLowerCase();
    return transportType === OPTION_SETS.transportType.options.cartravel.toLowerCase();
  }

  showTransportTypeOfPublicTravel(pageSectionIndex): boolean {
    const [pageIndex, sectionIndex] = this.getPageAndSectionIndex(pageSectionIndex);
    if (Number.isNaN(pageIndex) || Number.isNaN(sectionIndex)) { return false; }

    const formGroup = this.baseForm.form.controls.form as FormGroup;
    const pageArray: any = formGroup.get(`tabs.tab${NAV_TAB_NUMBERS.vptasApplication.travelAndAccommodation}.page${PAGE_NUMBERS.vptasApplicationForm.travelAndAccommodation}`);
    if (!pageArray?.controls || pageIndex < 0 || pageIndex >= pageArray.length) {
      return false;
    }

    const pageCtrl = pageArray.controls[pageIndex];
    const section = pageCtrl?.controls?.[SECTION_CODES.vptasApplicationForm.transportDetails];
    const idx = sectionIndex >= 0 ? sectionIndex : 0;
    const typeCode = SECTION_CODES.vptasApplicationForm.transportDetailsTransportType;
    const transportTypeCtrl = section?.controls?.[idx]?.controls?.[typeCode]
      || section?.controls?.[0]?.controls?.[typeCode]
      || section?.controls?.[typeCode];
    const transportType = (transportTypeCtrl?.value ?? '').toString().toLowerCase();
    return [
      OPTION_SETS.transportType.options.publictransport.toLowerCase(),
      OPTION_SETS.transportType.options.privateCar.toLowerCase()
    ].includes(transportType);
  }

  showTransportDetailsClaimAmount(pageSectionIndex): boolean {
    const [pageIndex, sectionIndex] = this.getPageAndSectionIndex(pageSectionIndex);
    if (Number.isNaN(pageIndex) || Number.isNaN(sectionIndex)) { return false; }

    const carTravelType = this.getTransportDetailsTypeOfCarTravel(pageIndex, sectionIndex)?.value;
    if (carTravelType != null) {
      if ([
        OPTION_SETS.transportType.options.communityTransport.toLowerCase(),
        OPTION_SETS.transportType.options.taxiRideShare.toLowerCase()
      ].includes(carTravelType.toLowerCase())) {
        return true;
      }
    }

    const publicTransportType = this.getTransportDetailsTypeOfPublicTravel(pageIndex, sectionIndex)?.value;
    if (publicTransportType != null) {
      if ([
        OPTION_SETS.transportType.options.skybus.toLowerCase(),
        OPTION_SETS.transportType.options.ferry.toLowerCase(),
        OPTION_SETS.transportType.options.commercialBus.toLowerCase()
      ].includes(publicTransportType.toLowerCase())) {
        return true;
      }
    }

    const transportDetailsTransportType = this.getTransportDetailsTransportType(pageIndex, sectionIndex)?.value;
    if (transportDetailsTransportType != null) {
      if ([
        OPTION_SETS.transportMode.options.commercialAirTravel.toLowerCase(),
        OPTION_SETS.transportMode.options.publictransport.toLowerCase()
      ].includes(transportDetailsTransportType.toLowerCase())) {
        return true;
      }
    }

    return false;
  }

  showtransportDetailsDocuments(pageSectionIndex) {
    const [pageIndex, sectionIndex] = this.getPageAndSectionIndex(pageSectionIndex);
    if (Number.isNaN(pageIndex) || Number.isNaN(sectionIndex)) { return false; }

    var carTravelType = this.getTransportDetailsTypeOfCarTravel(pageIndex, sectionIndex)?.value;
    if (carTravelType != null) {
      return ![
        OPTION_SETS.transportType.options.privateCar.toLowerCase(),
        OPTION_SETS.transportType.options.rentalCar.toLowerCase()
      ].includes(carTravelType.toLowerCase());
    }

    var publicTransportType = this.getTransportDetailsTypeOfPublicTravel(pageIndex, sectionIndex)?.value;
    if (publicTransportType != null) {
      return ![
        OPTION_SETS.transportType.options.ptvVLine.toLowerCase()
      ].includes(publicTransportType.toLowerCase());
    }

    return true;
  }

  ngOnInit(): void {

    this.formServiceEndpoint = API_ENDPOINT_KEYS.getVptasApplicationConfigAndResponse;
    this.saveEndpoint = API_ENDPOINTS.victorianPatientTransportAssistanceSchemeApplication.save;

    // Subscribe to route params and query params together to handle application source from popup
    this.registerSubscription(
      this.route.params.subscribe(params => {
        const routeId = params['id'];
        const routePersonId = params['personId'];

        if (routePersonId) {
          this.id = EMPTY_GUID + '/' + routePersonId;
        } else if (routeId) {
          this.id = routeId;
        }

        // Get query params and append to id if they exist
        const queryParams = this.route.snapshot.queryParams;
        const vptasApplicationSource = queryParams['vptasApplicationSource'];
        const vptasApplicationSourceDate = queryParams['vptasApplicationSourceDate'];

        if (vptasApplicationSource || vptasApplicationSourceDate) {
          let queryString = '';
          if (vptasApplicationSource) {
            queryString += `vptasApplicationSource=${encodeURIComponent(vptasApplicationSource)}`;
          }
          if (vptasApplicationSourceDate) {
            queryString += queryString ? '&' : '';
            queryString += `vptasApplicationSourceDate=${encodeURIComponent(vptasApplicationSourceDate)}`;
          }
          if (queryString && this.id) {
            this.id += (this.id.includes('?') ? '&' : '?') + queryString;
          }
        }
      })
    );

    this.coreService.conditionFunctions = {
      isEditing: () => this.editing,
      //exit: () => this.exit(),
      true: () => true,
      false: () => false,
      readOnly: () => true,
      isCustomerPortalApplication: () => false,
      isStaffPortalApplication: () => true,
      canShowBankDetails: () => this.canShowBankDetails(),
      // addNewPostalAddress: () => this.addNewPostalAddress(),
      showSignedApplicationUpload: () => false,
      isReadOnly: () => this.isReadOnly(),
      // isEditOrStaffPortalApplication: () => false,
      // isPostalAddressReadonly: () => this.isPostalAddressReadonly(),
      showtransportSection: (pageIndex) => this.showtransportSection(pageIndex),
      showAccommodationSection: (pageIndex) => this.showAccommodationSection(pageIndex),
      showSupportPersonOneSection: (pageIndex) => this.showSupportPersonOneSection(pageIndex),
      showSupportPersonTwoSection: (pageIndex) => this.showSupportPersonTwoSection(pageIndex),
      showSupportPersonOneSectionAndRelationshipToPatient: (pageIndex) => this.showSupportPersonOneSectionAndRelationshipToPatient(pageIndex), 
      showSupportPersonTwoSectionAndRelationshipToPatient: (pageIndex) => this.showSupportPersonTwoSectionAndRelationshipToPatient(pageIndex),
      showBlockTreatment: (pageindex) => this.showBlockTreatment(pageindex),
      showTreatmentDates: (pageindex) => this.showTreatmentDates(pageindex),
      showTransportDateOfReturn: (pageSectionIndex) => this.showTransportDateOfReturn(pageSectionIndex),
      showTransportReturnOnSameDay: (pageSectionIndex) => this.showTransportReturnOnSameDay(pageSectionIndex),
      showTransportTypeOfTravel: (pageSectionIndex) => this.showTransportTypeOfTravel(pageSectionIndex),
      showTransportTypeOfPublicTravel: (pageSectionIndex) => this.showTransportTypeOfPublicTravel(pageSectionIndex),
      showTreatmentEndDateWarningLabel: (pageIndex) => this.showTreatmentEndDateWarningLabel(pageIndex),
      showTransportDetailsDateOfTravelWarningLabel: (pageSectionIndex) => this.showTransportDetailsDateOfTravelWarningLabel(pageSectionIndex),
      showTransportDetailsCloneButton: (pageSectionIndex) => this.showTransportDetailsCloneButton(pageSectionIndex),
      showMultipleModes: (pageIndex) => this.showMultipleModes(pageIndex),
      showNumberOfNightsApprovedBySpecialists: (pageIndex) => this.showNumberOfNightsApprovedBySpecialists(pageIndex),
      showTransportDetailsClaimAmount: (pageSectionIndex) => this.showTransportDetailsClaimAmount(pageSectionIndex),
      showaccommodationDetailsClaimAmount: (pageSectionIndex) => true,
      showtransportDetailsDocuments: (pageSectionIndex) => this.showtransportDetailsDocuments(pageSectionIndex),
      showStartEndLocation: (sectionIndex) => this.showStartEndLocation(sectionIndex),
      showClaimTypes: (pageIndex) => this.showClaimTypes(pageIndex),
      showtransportDetailsDocumentsValidationMessage: (pageSectionIndex) => this.showtransportDetailsDocumentsValidationMessage(pageSectionIndex),
      showAccommodationDetailsDocumentsValidationMessage: (pageSectionIndex) => this.showAccommodationDetailsDocumentsValidationMessage(pageSectionIndex),
      isMultipleModesSelected: (pageIndex) => this.isMultipleModesSelected(pageIndex),
      showTransportDetailsTripType: () => this.showTransportDetailsTripType(),
      showSupportPersonInfantDeclaration: () => this.showSupportPersonInfantDeclaration(),
      showSupportPersonChildDeclaration: () => this.showSupportPersonChildDeclaration(),
      showSupportPersonAdultDeclaration: () => this.showSupportPersonAdultDeclaration(),
      showrelationshipToPatientIfNotAdult: () => this.showrelationshipToPatientIfNotAdult(),
      showSpecialistCustomType: (pageIndex) => this.showSpecialistCustomType(pageIndex),
      showSpecialistCustomTypeWarning: (pageIndex) => this.showSpecialistCustomTypeWarning(pageIndex)
    };

    this.coreService.applicationFunctions = {
      exit: () => this.exit(),
      isTriptypeDocsMandatory: (pageProps) => true,
      isSpecialistApprovalDocMandatory: (pageProps) => true,
      clone: (event, formModel = null, formControl = null) => this.clone(event, formModel, formControl),
      hasAccommodationDateOverlap: (pageIndex) => this.hasAccommodationDateOverlap(pageIndex),
      IsTransportDetailsTransportTypeValid: (pageAndSectionIndex) => this.IsTransportDetailsTransportTypeValid(pageAndSectionIndex),
      IsTransportDetailsTypeOfTravelValid: (pageAndSectionIndex) => this.IsTransportDetailsTypeOfCarTravelValid(pageAndSectionIndex),
      validateSupportScenarioTransport: (pageAndSectionIndex) => this.validateSupportScenarioTransport(pageAndSectionIndex),
      validateSupportScenarioAccommodation: (pageAndSectionIndex) => this.validateSupportScenarioAccommodation(pageAndSectionIndex),
      isTreatmentDateGreaterThanDateofBirth: (pageIndex) => this.isTreatmentDateGreaterThanDateofBirth(pageIndex),
      isDischargeDateWithinTreatmentDate: (pageIndex, valControl) => this.isDischargeDateWithinTreatmentDate(pageIndex, valControl),
      isTreatmentDateWithinDatePeriod: (pageIndex) => this.isTreatmentDateWithinDatePeriod(pageIndex),
      isTravelDatewithinTreamentDateRange: (pageIndex, sectionIndex, valControl) => this.isTravelDatewithinTreamentDateRange(pageIndex, sectionIndex, valControl),
      hasAccommodationSpecialistDate: (pageIndex) => this.hasAccommodationSpecialistDate(pageIndex),
      genderMandatory: (pageIndex) => this.genderMandatory(pageIndex),
      searchSpecialist: (event, formModel = null, formControl = null) => this.searchSpecialist(event, formModel, formControl),
    }

    this.coreService.repeatingPageFunctions = {
    };

    this.coreService.repeatingSectionFunctions = {
      subscribeToIsMultipleModes: (itemIndex: number, onComplete: (cancel: boolean) => void) => this.subscribeToIsMultipleModes(itemIndex, onComplete)
    };

    this.registerOnNavigation();
  }
  
  showAdmissionDischargeDates(pageIndex: any) {
    const formGroup = this.baseForm?.form?.controls?.form as FormGroup;
    if (!formGroup) { return false; }

    const idx = Number(pageIndex);
    if (Number.isNaN(idx)) { return false; }

    const approvedSpecialistSection = formGroup.get(
      `tabs.tab${NAV_TAB_NUMBERS.vptasApplication.travelAndAccommodation}.page${PAGE_NUMBERS.vptasApplicationForm.travelAndAccommodation}.${idx}.${SECTION_CODES.vptasApplicationForm.approvedSpecialistService}`
    ) as FormGroup;

    const isHospitalAdmissionControl = formGroup.get(
      `tabs.tab${NAV_TAB_NUMBERS.vptasApplication.travelAndAccommodation}.page${PAGE_NUMBERS.vptasApplicationForm.travelAndAccommodation}.${idx}.${SECTION_CODES.vptasApplicationForm.approvedSpecialistService}.approvedSpecialistServiceIsHospitalAdmission`
    );

    const rawValue = isHospitalAdmissionControl?.value;
    const isHospitalAdmission = rawValue === true || rawValue?.toString?.().toLowerCase() === OPTION_SETS.yesNo.options.yes;
    if (!isHospitalAdmission) { return false; }

    if (!approvedSpecialistSection) { return true; }

    const treatmentStartDate = this.getTreatmentStartDate(idx);
    const treatmentEndDate = this.getTreatmentEndDate(idx);

    const admissionDateControl = approvedSpecialistSection.get('admissionDate');
    const dischargeDateControl = approvedSpecialistSection.get('dischargeDate');

    const patch: any = {};
    if (admissionDateControl && !admissionDateControl.value) {
      if (treatmentStartDate) {
        patch.admissionDate = this.dateUtil.formatToUIDateTimeFormat(treatmentStartDate);
      }
    }
    if (dischargeDateControl && !dischargeDateControl.value) {
      if (treatmentEndDate) {
        patch.dischargeDate = this.dateUtil.formatToUIDateTimeFormat(treatmentEndDate);
      }
    }

    if (Object.keys(patch).length > 0) {
      approvedSpecialistSection.patchValue(patch, { emitEvent: false });
    }

    return true;
  }

  genderMandatory(pageIndex: any) {
    return true;
  }

  showTransportDetailsDateOfTravelWarningLabel(pageSectionIndex): boolean {
    const [pageIndex, sectionIndex] = this.getPageAndSectionIndex(pageSectionIndex);
    const typeOfControl = pageSectionIndex[2];
    const key = `${pageIndex}-${sectionIndex}-${typeOfControl}`;
    return this.travelDateValidationStatus[key] === true;
  }

  showTreatmentEndDateWarningLabel(pageIndex: any) {
    return this.treatmentDateValidationStatus[pageIndex] === true;
  }

  private isTreatmentDateWithinDatePeriod(pageIndex: any) {
    const formGroup = this.baseForm?.form?.controls?.form as FormGroup;
    if (!formGroup) { return null; }

    const treatmentEndDateControl = formGroup.get(
      `tabs.tab${NAV_TAB_NUMBERS.vptasApplication.travelAndAccommodation}.page${PAGE_NUMBERS.vptasApplicationForm.travelAndAccommodation}.${pageIndex}.${SECTION_CODES.vptasApplicationForm.approvedSpecialistService}.${QUESTION_CODES.vptasApplicationForm.treatmentEndDate}`
    );

    if (!treatmentEndDateControl?.value) {
      return null;
    }

    const treatmentEndDate = this.dateUtil.parseDate(treatmentEndDateControl.value);
    if (!treatmentEndDate) {
      return null;
    }

    treatmentEndDate.setHours(0, 0, 0, 0);

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const twelveMonthsAgo = new Date(today);
    twelveMonthsAgo.setMonth(twelveMonthsAgo.getMonth() - 12);

    const treatmentEndTime = treatmentEndDate.getTime();
    const twelveMonthsAgoTime = twelveMonthsAgo.getTime();
    const isValid = treatmentEndTime >= twelveMonthsAgoTime;

    this.treatmentDateValidationStatus[pageIndex] = !isValid;

    return true;
  }

  private hasAccommodationSpecialistDate(pageIndex: any) {
    const formGroup = this.baseForm?.form?.controls?.form as FormGroup;
    if (!formGroup) { return null; }

    const treatmentStartDateControl = formGroup.get(
      `tabs.tab${NAV_TAB_NUMBERS.vptasApplication.travelAndAccommodation}.page${PAGE_NUMBERS.vptasApplicationForm.travelAndAccommodation}.${pageIndex}.${SECTION_CODES.vptasApplicationForm.approvedSpecialistService}.${QUESTION_CODES.vptasApplicationForm.treatmentStartDate}`
    );

    const numberOfNightsApprovedBySpecialistControl = formGroup.get(
      `tabs.tab${NAV_TAB_NUMBERS.vptasApplication.travelAndAccommodation}.page${PAGE_NUMBERS.vptasApplicationForm.travelAndAccommodation}.${pageIndex}.${SECTION_CODES.vptasApplicationForm.approvedSpecialistService}.${QUESTION_CODES.vptasApplicationForm.numberOfNightsApprovedBySpecialist}`
    );

    const accommodationDetailsControl = formGroup.get(`tabs.tab${NAV_TAB_NUMBERS.vptasApplication.travelAndAccommodation}.page${PAGE_NUMBERS.vptasApplicationForm.travelAndAccommodation}.${pageIndex}.${SECTION_CODES.vptasApplicationForm.accommodationDetails}`) as any;

    const isHospitalAdmissionControl = formGroup.get(
      `tabs.tab${NAV_TAB_NUMBERS.vptasApplication.travelAndAccommodation}.page${PAGE_NUMBERS.vptasApplicationForm.travelAndAccommodation}.${pageIndex}.${SECTION_CODES.vptasApplicationForm.approvedSpecialistService}.approvedSpecialistServiceIsHospitalAdmission`
    );

    const admissionDateControl = formGroup.get(
      `tabs.tab${NAV_TAB_NUMBERS.vptasApplication.travelAndAccommodation}.page${PAGE_NUMBERS.vptasApplicationForm.travelAndAccommodation}.${pageIndex}.${SECTION_CODES.vptasApplicationForm.approvedSpecialistService}.admissionDate`
    );

    const dischargeDateControl = formGroup.get(
      `tabs.tab${NAV_TAB_NUMBERS.vptasApplication.travelAndAccommodation}.page${PAGE_NUMBERS.vptasApplicationForm.travelAndAccommodation}.${pageIndex}.${SECTION_CODES.vptasApplicationForm.approvedSpecialistService}.dischargeDate`
    );

    if (!numberOfNightsApprovedBySpecialistControl?.value || !accommodationDetailsControl) {
      return null;
    }

    let numberOfNightsApproved = Number(numberOfNightsApprovedBySpecialistControl.value);

    const isHospitalAdmission = isHospitalAdmissionControl?.value === true ||
      isHospitalAdmissionControl?.value?.toString?.().toLowerCase() === 'yes';

    if (isHospitalAdmission && admissionDateControl?.value && dischargeDateControl?.value) {
      const admissionDate = this.dateUtil.parseDate(admissionDateControl.value);
      const dischargeDate = this.dateUtil.parseDate(dischargeDateControl.value);

      if (admissionDate && dischargeDate) {
        admissionDate.setHours(0, 0, 0, 0);
        dischargeDate.setHours(0, 0, 0, 0);

        const timeDifferenceMs = dischargeDate.getTime() - admissionDate.getTime();
        const hospitalNights = Math.floor(timeDifferenceMs / (1000 * 60 * 60 * 24));

        numberOfNightsApproved += hospitalNights;
      }
    }

    const accommodationItems = Array.isArray(accommodationDetailsControl.controls)
      ? accommodationDetailsControl.controls.map((ctrl: any) => ctrl.getRawValue())
      : [];

    if (accommodationItems.length === 0) {
      return null;
    }

    let totalNights = 0;
    for (const item of accommodationItems) {
      const checkInDate = this.dateUtil.parseDate(item?.accommodationDetailsCheckInDate);
      const checkOutDate = this.dateUtil.parseDate(item?.accommodationDetailsCheckOutDate);

      if (checkInDate && checkOutDate) {
        checkInDate.setHours(0, 0, 0, 0);
        checkOutDate.setHours(0, 0, 0, 0);

        const timeDifferenceMs = checkOutDate.getTime() - checkInDate.getTime();
        const nightsDifference = Math.floor(timeDifferenceMs / (1000 * 60 * 60 * 24));
        totalNights += nightsDifference;
      }
    }

    if (totalNights == 0)
      return true;
    return totalNights <= numberOfNightsApproved;
  }

  isTravelDatewithinTreamentDateRange(pageProps: any, sectionIndex: any, valControl: any) {
    const formGroup = this.baseForm?.form?.controls?.form as FormGroup;
    if (!formGroup) { return null; }

    const pageIndex = pageProps[0];
    sectionIndex = pageProps[1];
    valControl = pageProps[2];
    const typeOfControl = pageProps[3];

    const treatmentStartDateControl = formGroup.get(
      `tabs.tab${NAV_TAB_NUMBERS.vptasApplication.travelAndAccommodation}.page${PAGE_NUMBERS.vptasApplicationForm.travelAndAccommodation}.${pageIndex}.${SECTION_CODES.vptasApplicationForm.approvedSpecialistService}.${QUESTION_CODES.vptasApplicationForm.treatmentStartDate}`
    );

    const travelDateControl = valControl.formControl;
    if (!treatmentStartDateControl?.value || !travelDateControl?.value) {
      return null;
    }

    const treatmentStartDate = this.dateUtil.parseDate(treatmentStartDateControl.value);
    const travelDate = this.dateUtil.parseDate(travelDateControl.value);

    if (!treatmentStartDate || !travelDate) {
      return null;
    }

    const allowedEarliestTravelDate = new Date(treatmentStartDate);
    allowedEarliestTravelDate.setDate(allowedEarliestTravelDate.getDate() - 2);

    treatmentStartDate.setHours(0, 0, 0, 0);
    travelDate.setHours(0, 0, 0, 0);
    allowedEarliestTravelDate.setHours(0, 0, 0, 0);

    const travelTime = travelDate.getTime();
    const allowedEarliestTime = allowedEarliestTravelDate.getTime();
    const isValid = travelTime >= allowedEarliestTime;

    const key = `${pageIndex}-${sectionIndex}-${typeOfControl}`;
    this.travelDateValidationStatus[key] = !isValid;

    return true;
  }

  private isDischargeDateWithinTreatmentDate(pageProps: any, valControl: any) {
    const formGroup = this.baseForm?.form?.controls?.form as FormGroup;
    if (!formGroup) { return null; }
    var pageIndex = pageProps[0];
    valControl = pageProps[1];

    var startDate = null;
    var endDate = null;
    if (this.getIsBlockTreatement()) {
      var dates = this.getBlockTreatmentDates(0);
      if (dates == null) {
        return null;
      }
      startDate = dates[0];
      endDate = dates[dates.length - 1];
    }
    else {
      const treatmentStartDate = formGroup.get(
        `tabs.tab${NAV_TAB_NUMBERS.vptasApplication.travelAndAccommodation}.page${PAGE_NUMBERS.vptasApplicationForm.travelAndAccommodation}.${pageIndex}.${SECTION_CODES.vptasApplicationForm.approvedSpecialistService}.${QUESTION_CODES.vptasApplicationForm.treatmentStartDate}`
      )?.value;

      const treatmentEndDate = formGroup.get(
        `tabs.tab${NAV_TAB_NUMBERS.vptasApplication.travelAndAccommodation}.page${PAGE_NUMBERS.vptasApplicationForm.travelAndAccommodation}.${pageIndex}.${SECTION_CODES.vptasApplicationForm.approvedSpecialistService}.${QUESTION_CODES.vptasApplicationForm.treatmentEndDate}`
      )?.value;

      if (!treatmentStartDate || !treatmentEndDate) {
        return null;
      }

      startDate = this.dateUtil.parseDate(treatmentStartDate);
      endDate = this.dateUtil.parseDate(treatmentEndDate);
    }

    const dischargeDateStr = valControl.formControl?.value ?? formGroup.get(
      `tabs.tab${NAV_TAB_NUMBERS.vptasApplication.travelAndAccommodation}.page${PAGE_NUMBERS.vptasApplicationForm.travelAndAccommodation}.${pageIndex}.${SECTION_CODES.vptasApplicationForm.approvedSpecialistService}.${valControl.key}`
    )?.value;

    if (dischargeDateStr == null) {
      return null;
    }

    const dischargeDate = this.dateUtil.parseDate(dischargeDateStr);

    if (!startDate || !endDate || !dischargeDate) {
      return null;
    }

    const startTime = startDate.getTime();
    const endTime = endDate.getTime();
    const dischargeTime = dischargeDate.getTime();

    return dischargeTime >= startTime && dischargeTime <= endTime;
  }

  private isTreatmentDateGreaterThanDateofBirth(pageProps: any) {
    const formGroup = this.baseForm?.form?.controls?.form as FormGroup;
    if (!formGroup) { return; }
    var pageIndex = pageProps[0];
    const valControl = pageProps[1];
    const dobControl = formGroup.get(
      `tabs.tab${NAV_TAB_NUMBERS.vptasApplication.applicant}.page${PAGE_NUMBERS.vptasApplicationForm.applicantProfile}.${SECTION_CODES.vptasApplicationForm.profile}.dateOfBirth`
    );
    let treatmentStartDateControl = valControl;
    if (valControl.key === QUESTION_CODES.vptasApplicationForm.treatmentStartDate) {
      treatmentStartDateControl = formGroup.get(
        `tabs.tab${NAV_TAB_NUMBERS.vptasApplication.travelAndAccommodation}.page${PAGE_NUMBERS.vptasApplicationForm.travelAndAccommodation}.${pageIndex}.${SECTION_CODES.vptasApplicationForm.approvedSpecialistService}.${QUESTION_CODES.vptasApplicationForm.treatmentStartDate}`
      );
    }
    else {
      treatmentStartDateControl = formGroup.get(
        `tabs.tab${NAV_TAB_NUMBERS.vptasApplication.travelAndAccommodation}.page${PAGE_NUMBERS.vptasApplicationForm.travelAndAccommodation}.${pageIndex}.${SECTION_CODES.vptasApplicationForm.approvedSpecialistService}.${QUESTION_CODES.vptasApplicationForm.treatmentDates}`
      );

    }
    if (!treatmentStartDateControl?.value) { return null; }

    let dateValue = treatmentStartDateControl.value;
    let startDate: Date;

    // If the value is an array (treatment dates range), get the lower (earlier) date
    if (Array.isArray(dateValue) && dateValue.length > 0) {
      const parsedDates = dateValue
        .map(d => this.dateUtil.parseDate(d))
        .filter(d => d !== null && d !== undefined);

      if (parsedDates.length === 0) { return null; }

      startDate = parsedDates.reduce((earliest, current) =>
        current.getTime() < earliest.getTime() ? current : earliest
      );
    } else {
      startDate = this.dateUtil.parseDate(dateValue);
    }

    const dob = this.dateUtil.parseDate(dobControl?.value);

    if (!startDate || !dob) { return null; }
    if (startDate.getTime() < dob.getTime()) {
      return false;
    }
    return true;
  }

  private getBlockTreatmentDates(pageIndex) {
    const formGroup = this.baseForm?.form?.controls?.form as FormGroup;
    var dates = formGroup.get(
      `tabs.tab${NAV_TAB_NUMBERS.vptasApplication.travelAndAccommodation}.page${PAGE_NUMBERS.vptasApplicationForm.travelAndAccommodation}.${pageIndex}.${SECTION_CODES.vptasApplicationForm.approvedSpecialistService}.${QUESTION_CODES.vptasApplicationForm.treatmentDates}`
    )?.value;

    if (dates != null && Array.isArray(dates) && dates.length > 0) {
      const parsedDates = dates
        .map(d => this.dateUtil.parseDate(d))
        .filter(d => d !== null && d !== undefined);

      if (parsedDates.length === 0) {
        return null;
      }

      return parsedDates;
    }
    else {
      return null;
    }
  }

  ngOnDestroy(): void {
    this.revertBackToDefaultSummaryAndDocumentListComponents();
    this.unsubscribeSubscriptions();
    this.formNavSubscription.unsubscribe();
    this.coreService.applicationFunctions = {};
    this.coreService.repeatingPageFunctions = {};
    // Clean up patient DOB subscription
    if (this.patientDobSubscription && !this.patientDobSubscription.closed) {
      this.patientDobSubscription.unsubscribe();
    }

    if (this.treatmentLocationSubscription && !this.treatmentLocationSubscription.closed) {
      this.treatmentLocationSubscription.unsubscribe();
    }

    // Clean up transport mode subscriptions
    Object.values(this.transportModeSubscriptions).forEach(sub => {
      if (sub && !sub.closed) {
        sub.unsubscribe();
      }
    });
    this.transportModeSubscriptions = {};
    this.coreService.repeatingSectionFunctions = {};
  }

  formLoaded($event) {
    if (this.baseForm && this.baseForm.model) {
      this.appDataService.setAppData(APP_DATA_KEYS.previousModel, JSON.parse(JSON.stringify(this.baseForm.model)));
    }
    this.activeApplications = $event.activateApplications;
    this.formHeaderModel = $event.headerResponse;

    // Map all VPTAS file upload question codes to a valid form identifier header
    this.coreService.fileUploadFormIdentifiers['testDocumentsPlaceholder'] = FORM_IDENTIFIERS.vptsFormIdentifier;
    this.coreService.fileUploadFormIdentifiers['tripAccommodationDocument'] = FORM_IDENTIFIERS.vptsFormIdentifier;
    this.coreService.fileUploadFormIdentifiers['specialistApprovalDocument'] = FORM_IDENTIFIERS.vptsFormIdentifier;
    this.coreService.fileUploadFormIdentifiers['entitlementLetter'] = FORM_IDENTIFIERS.vptsFormIdentifier;
    this.coreService.fileUploadFormIdentifiers['signedApplication'] = FORM_IDENTIFIERS.vptsFormIdentifier;
    this.coreService.fileUploadFormIdentifiers['tripTransportDocument'] = FORM_IDENTIFIERS.vptsFormIdentifier;
    this.coreService.fileUploadFormIdentifiers['transportDetailsDocuments'] = FORM_IDENTIFIERS.vptsFormIdentifier;
    this.coreService.fileUploadFormIdentifiers['accommodationDetailsDocuments'] = FORM_IDENTIFIERS.vptsFormIdentifier;
    this.coreService.fileUploadFormIdentifiers['userDeclarationDocument'] = FORM_IDENTIFIERS.vptsFormIdentifier;


    this.patientOptions = $event.patientOptions;
    setTimeout(() => { // Delay execution until form controls finish rendering
      this.registerCustomFormListners($event);
      this.defaultFirstTransportLocationsFromResidential();
    });

    this.isDraftApplication = $event.isDraftApplication;

    this.setCurrentTreatementLocation();
    this.updateAddBlockAvailabilityBasedOnIsBlockTreatmentQuestion();
    this.appDataService.setVptasBlockValidationSummary($event.blockTreatmentValidationResults);
    this.appDataService.setVptasStandardValidationSummary($event.standardTreatmentValidationResults);
    this.appDataService.setSubsidiesPayableResults($event.subsidiesPayableResults);
    this.appDataService.setIsCoPaymentRequired($event.coPaymentRequired);
    this.appDataService.setSystemIneligibleReason($event.systemIneligibilityReason);

    // Initialize subscribeToIsMultipleModes for the first page
    setTimeout(() => {
      this.subscribeToIsMultipleModes(0, () => { });
    }, 100);

    const stepTwoTab = NAV_TAB_NUMBERS.vptasApplication.applicant;
    const stepTwoPage = PAGE_NUMBERS.vptasApplicationForm.applicantProfile;
    this._hasAppliedInitialApplicantStep = false;
    this.setCurrentTabAndPage(stepTwoTab, stepTwoPage);
    setTimeout(() => {
      this.setActiveTabAndPage(stepTwoTab, stepTwoPage);
    });

  }

  exit() {
    this.navigateBackToHome();
  }

  save(event: SaveFormEvent) {
    // Support composite id in the format "<applicationId>/<personId>"
    const { appId, personId, vptasApplicationSource, vptasApplicationSourceDate } = this.parseCompositeId(this.id);
    const saveDataRequest: SaveDataRequest & {
      personId?: string;
      vptasApplicationSource?: string;
      vptasApplicationSourceDate?: string;
    } = {
      template: this.templateId,
      versionNumber: this.versionNo,
      id: appId,
      response: event.model,
      expectedLastUpdateTime: event.lastUpdatedTime,
      isSubmit: event.isSubmit,
      personId: personId,
      vptasApplicationSource: vptasApplicationSource,
      vptasApplicationSourceDate: vptasApplicationSourceDate
    }
    if (event.isSubmit) {
      if (event.isFormValid === false) {
        this.baseForm.markAllFieldsAsTouched();
        this.baseForm.showValidationSummary(true);
      }
      else {
        this.saveData(saveDataRequest);
      }
    }
    else {
      this.saveData(saveDataRequest);
    }
  }

  private parseCompositeId(rawId: string): { appId: string; personId?: string; vptasApplicationSource?: string; vptasApplicationSourceDate?: string } {
    if (!rawId) return { appId: '' };

    // Split on '?' to separate ID from query parameters
    const [cleanId, queryString] = rawId.split('?');

    const parts = cleanId.split('/');
    const result: { appId: string; personId?: string; vptasApplicationSource?: string; vptasApplicationSourceDate?: string } = {
      appId: parts[0],
      personId: parts.length > 1 ? parts[1] : undefined
    };

    // Parse specific query parameters if they exist
    if (queryString) {
      const searchParams = new URLSearchParams(queryString);

      const vptasApplicationSource = searchParams.get('vptasApplicationSource');
      const vptasApplicationSourceDate = searchParams.get('vptasApplicationSourceDate');

      if (vptasApplicationSource) {
        result.vptasApplicationSource = vptasApplicationSource;
      }

      if (vptasApplicationSourceDate) {
        result.vptasApplicationSourceDate = vptasApplicationSourceDate;
      }
    }

    return result;
  }
  cancel(event: any) {
    this.formNavigationService.moveBack();
  }

  buttonClick(event: any): void {
  }

  actionButtonClick(event: any): void {
  }

  dialogButton_submitIneligible_Clicked(event: any): void {
    switch (this.activeDialog) {
      case POP_UP_CODES.common.submitSuccessful: {
        this.navigateBackToHome(true);
        break;
      }
      case POP_UP_CODES.common.submitIneligible: {
        this.navigateToApplicationDetailPage(true);
        break;
      }
    }
  }

  dialogButton_submitSuccessful_Clicked(event: any): void {
    switch (this.activeDialog) {
      case POP_UP_CODES.common.submitSuccessful: {
        this.navigateBackToHome(true);
        break;
      }
      case POP_UP_CODES.common.submitIneligible: {
        this.navigateBackToHome(true);
        break;
      }
    }
  }

  filter(event: any): void {
  }

  modelChange(event: any): void {
    if (this.baseForm?.model) {

      // var addressSection = this.baseForm?.model?.form?.tabs?.tab2?.page1?.address;
      // if (addressSection) {
      //   var value = addressSection[QUESTION_CODES.nonMainsMedicalCoolingForm.primaryAddressManualAddress];
      //   this.primaryAddressIsManual = (value === true);
      // }

      // TODO: Update when creating the header
      // this.UpdateHeaderAndApplicationPeriod();
    }
  }

  // private UpdateHeaderAndApplicationPeriod() {
  // TODO: Update and uncomment after backend is completed.
  // let applicationPeriod = this.updateHeaderSubtitle(this.baseForm.optionSets.summermonths);
  // if (applicationPeriod) {
  //   this.baseForm.model.form.tabs.tab5.page1.invoiceUpload.applicationPeriod = applicationPeriod;
  // }
  // }

  // isPrimaryAddressManual(): boolean {
  //   return this.primaryAddressIsManual;
  // }

  // isPrimaryAddressAuto(): boolean {
  //   return !this.primaryAddressIsManual;
  // }

  private navigateBackToHome(ignoreUnsavedChanges = false): void {
    const target = ROUTE_CONSTANTS.vptasApplication.list.myApplications; // e.g. 'vptas-application-list/my-applications'
    const segments = typeof target === 'string' ? target.replace(/^\//, '').split('/') : [target as any];
    this.navigate(['/', ...segments], ignoreUnsavedChanges);
  }

  showHideQuestionsOnSummary(): void {
    this.showHideAddressesOnSummary();
  }

  showHideAddressesOnSummary() {
    throw new Error('Method not implemented.');
  }

  protected isReadOnly() {
    return false;
  }

  // protected isPostalAddressReadonly() {
  //   return false;
  // }

  // protected isConsentAgree(): boolean {
  //   return this.baseForm?.model?.form?.tabs?.tab4?.page1?.cardDetails?.consent == OPTION_SETS.concessionConsentType.options.agree;
  // }

  // protected addNewPostalAddress() {
  //   return this.baseForm?.model?.form?.tabs?.tab2?.page1?.address?.postalAddressSameAsPrimaryAddress == OPTION_SETS.postalAddressSameOrDifferent.options.addNewPostalAddress;
  // }

  hasValidationErrorMessages = false;
  saveData(request: SaveDataRequest) {
    if (!this.validateProviderPaymentIfFinancialInstitution()) {
      this.activeDialog = POP_UP_CODES.bankDetail.noFinancialInstitutionProviderPaymentConfirmation;
      this.dialogService.showDialog(this.activeDialog);
      return ;
    }
    else { 
    this.spinnerService.showSpinner();
    this.registerSubscription(
      this.dataService.saveData(this.saveEndpoint, request)
        .pipe(
          take(1),
          this.errorService.errorHandler(),
          finalize(() => this.spinnerService.hideSpinner())
        )
        .subscribe(data => {
          if (data?.status === SAVE_RESULT_STATUS.success) {
            if (SERVER_ERROR_POP_UP_CODES.saveConcessionsApplication.includes(data.message)) {
              this.activeDialog = data.message;
              this.dialogService.showDialog(this.activeDialog, null, { address: data?.addressPlaceHolder });
            }
            else {
              if (request.isSubmit) {
                if (data.applicationStatusId === REFERENCE_DATA_IDS.vptasApplicationStatus.ineligible) {
                  const messagePlaceholders = {
                    applicationReferenceNumber: data?.applicationReferenceNumber
                  };
                  this.activeDialog = POP_UP_CODES.common.submitIneligible;
                  this.dialogService.showDialog(POP_UP_CODES.common.submitIneligible, null, messagePlaceholders);
                }
                else {
                  this.id = data.id;
                  if(this.id != null){
                    this.navigateToApplicationDetailPage(true);
                  }
                  else{
                    this.navigateBackToHome(true);
                  }
                }
              } else {
                if (data.hasPlacementsForCarer == "true") {
                  this.activeDialog = POP_UP_CODES.victorianPatientTransportAssistanceScheme.userUpdateCarerPlacementWarning;
                  this.dialogService.showDialog(this.activeDialog);
                }
                // if (data.centrelinkCardCheckResponse != null && data.centrelinkCardCheckResponse?.isValid == false) {
                //   var popupCode = POP_UP_CODES.common.centrelinkCardMatch;
                //   this.activeDialog = popupCode;
                //   this.dialogService.showDialog(this.activeDialog);
                // }
                this.id = data.id;
                this.baseForm.lastUpdatedTime = data.allocatedLastUpdatedTime;
                this.setPreviousModel();
                this.appDataService.setVptasBlockValidationSummary(data.blockTreatmentValidationResults);
                this.appDataService.setVptasStandardValidationSummary(data.standardTreatmentValidationResults);
                this.appDataService.setSubsidiesPayableResults(data.subsidiesPayableResults);
                this.appDataService.setIsCoPaymentRequired(data.coPaymentRequired);
                this.appDataService.setSystemIneligibleReason(data.systemIneligibilityReason);
              }
            }
          }
        })
      );
    }
  }

  private hasAccommodationDateOverlap(pageIndex: number): boolean {
    const accommodationitems = this.getTravelAndAccomdationPage(pageIndex)?.value?.accommodationDetails;
    if (accommodationitems != null && (!Array.isArray(accommodationitems) || accommodationitems.length < 2)) { return true; }

    // Validate order per item (end >= start). Any invalid => invalid overall
    for (const it of accommodationitems) {
      const s = this.dateUtil.parseDate(it?.accommodationDetailsCheckInDate);
      const e = this.dateUtil.parseDate(it?.accommodationDetailsCheckOutDate);
      if (!s || !e) { continue; }
      if (e.getTime() < s.getTime()) { return false; }
    }

    // Overlap check: if any item overlaps any other (ignoring itself), return false
    for (let i = 0; i < accommodationitems.length; i++) {
      const cur = accommodationitems[i];
      const startVal = cur?.accommodationDetailsCheckInDate;
      const endVal = cur?.accommodationDetailsCheckOutDate;
      if (this.dateUtil.rangeOverlapsAny(startVal, endVal, accommodationitems, 'accommodationDetailsCheckInDate', 'accommodationDetailsCheckOutDate', i)) {
        return false;
      }
    }

    // No overlaps detected
    return true;
  }
  /**
   * Helper: Get transport details section for a given pageIndex
   */
  private getTransportDetails(pageIndex: number): any {
    return (this.baseForm.form.controls.form as FormGroup).get(`tabs.tab${NAV_TAB_NUMBERS.vptasApplication.travelAndAccommodation}.page${PAGE_NUMBERS.vptasApplicationForm.travelAndAccommodation}.${pageIndex}.${SECTION_CODES.vptasApplicationForm.transportDetails}`);
  }

  /**
   * Helper: Get accommodation details section for a given pageIndex
   */
  private getAccommodationDetails(pageIndex: number): any {
    return (this.baseForm.form.controls.form as FormGroup).get(`tabs.tab${NAV_TAB_NUMBERS.vptasApplication.travelAndAccommodation}.page${PAGE_NUMBERS.vptasApplicationForm.travelAndAccommodation}.${pageIndex}.${SECTION_CODES.vptasApplicationForm.accommodationDetails}`);
  }

  showSupportPersonOneSection(pageIndex) {
    // Block treatment check: If block treatment is selected, support person sections should not be shown
    if (this.getIsBlockTreatement()) {
      return false;
    }

    const transportDetails = this.getTransportDetails(pageIndex);
    const accommodationDetails = this.getAccommodationDetails(pageIndex);

    const escortOnlyId = VPTAS_CLAIM_FOR_IDS.escortOnly.toLowerCase();
    const patientAndEscortId = VPTAS_CLAIM_FOR_IDS.patientAndEscort.toLowerCase();
    const patientAndTwoEscortsId = VPTAS_CLAIM_FOR_IDS.patientAndTwoEscorts.toLowerCase();
    const twoEscortsId = VPTAS_CLAIM_FOR_IDS.twoEscorts.toLowerCase();

    // Check transport details
    const transportHasClaimFor = transportDetails?.value?.some((x: any) => {
      const claimedFor = x?.transportDetailsClaimedFor?.toString().toLowerCase();
      return claimedFor === escortOnlyId ||
        claimedFor === patientAndEscortId ||
        claimedFor === patientAndTwoEscortsId ||
        claimedFor === twoEscortsId;
    });

    // Check accommodation details
    const accommodationHasClaimFor = accommodationDetails?.value?.some((x: any) => {
      const claimedFor = x?.accommodationDetailsClaimedFor?.toString().toLowerCase();
      return claimedFor === escortOnlyId ||
        claimedFor === patientAndEscortId ||
        claimedFor === patientAndTwoEscortsId ||
        claimedFor === twoEscortsId;
    });

    return transportHasClaimFor || accommodationHasClaimFor;
  }

  showSupportPersonTwoSection(pageIndex) {
    // Block treatment check: If block treatment is selected, support person sections should not be shown
    if (this.getIsBlockTreatement()) {
      return false;
    }

    const transportDetails = this.getTransportDetails(pageIndex);
    const accommodationDetails = this.getAccommodationDetails(pageIndex);

    const patientAndTwoEscortsId = VPTAS_CLAIM_FOR_IDS.patientAndTwoEscorts.toLowerCase();
    const twoEscortsId = VPTAS_CLAIM_FOR_IDS.twoEscorts.toLowerCase();

    // Check transport details
    const transportHasClaimFor = transportDetails?.value?.some((x: any) => {
      const claimedFor = x?.transportDetailsClaimedFor?.toString().toLowerCase();
      return claimedFor === patientAndTwoEscortsId || claimedFor === twoEscortsId;
    });

    // Check accommodation details
    const accommodationHasClaimFor = accommodationDetails?.value?.some((x: any) => {
      const claimedFor = x?.accommodationDetailsClaimedFor?.toString().toLowerCase();
      return claimedFor === patientAndTwoEscortsId || claimedFor === twoEscortsId;
    });

    return transportHasClaimFor || accommodationHasClaimFor;
  }

  canShowBankDetails() {
   var noBankDetailsChecked = (this.baseForm.form.controls.form as FormGroup).get(`tabs.tab${NAV_TAB_NUMBERS.vptasApplication.applicant}.page${PAGE_NUMBERS.vptasApplicationForm.applicantProfile}.${SECTION_CODES.vptasApplicationForm.bankDetails}.${QUESTION_CODES.vptasApplicationForm.noApplicantBankDetails}`)?.value;
    return noBankDetailsChecked !== true;
  }

  validateProviderPaymentIfFinancialInstitution(): boolean {
    const isOnRelevantPage =
      this._currentTab === NAV_TAB_NUMBERS.vptasApplication.travelAndAccommodation &&
      this._currentPage === PAGE_NUMBERS.vptasApplicationForm.travelAndAccommodation &&
      this.baseForm?.model?.form?.tabs?.[`tab${NAV_TAB_NUMBERS.vptasApplication.applicant}`]
        ?.[`page${PAGE_NUMBERS.vptasApplicationForm.applicantProfile}`]?.bankDetails?.noApplicantBankDetails;

    if (!isOnRelevantPage) {
      return true;
    }

    const claimType = this.getClaimTypesControl(PAGE_NUMBERS.vptasApplicationForm.travelAndAccommodation - 1)?.value;
    const page1 = this.baseForm?.model?.form?.tabs?.[`tab${NAV_TAB_NUMBERS.vptasApplication.travelAndAccommodation}`]
      ?.[`page${PAGE_NUMBERS.vptasApplicationForm.travelAndAccommodation}`]?.[0];
    const payToSelf = OPTION_SETS.vptasaccommodationpaytooptionscategory.options.paytoSelfCode;

    const transportPaysSelf = (page1?.transportDetails ?? []).some(
      (detail: any) => detail?.transportDetailsWhoShouldPay === payToSelf);

    const accommodationPaysSelf = (page1?.accommodationDetails ?? []).some(
      (detail: any) => detail?.accommodationDetailsWhoShouldPay === payToSelf);

    switch (claimType) {
      case OPTION_SETS.claimTypes.options.Accommodation.toLowerCase():
        return !accommodationPaysSelf;
      case OPTION_SETS.claimTypes.options.Transport.toLowerCase():
        return !transportPaysSelf;
      case OPTION_SETS.claimTypes.options.Both.toLowerCase():
        return !(transportPaysSelf || accommodationPaysSelf);
      default:
        return true;
    }
  }

  showAccommodationSection(pageIndex) {
    var isBlockTreatment = this.getIsBlockTreatementControl()?.value;
    var claimType = this.getClaimTypesControl(pageIndex)?.value;

    if (isBlockTreatment == OPTION_SETS.yesNo.options.yes) {
      return false;
    }

    var claimTypeLowerCase = claimType?.toLowerCase();
    const shouldShow = claimTypeLowerCase == OPTION_SETS.claimTypes.options.Accommodation.toLowerCase()
      || claimTypeLowerCase == ClaimTypes.Both.toLowerCase();

    // AC01: Populate accommodation date fields when section is shown
    if (shouldShow) {
      this.populateAccommodationDateFieldsFromTreatment(pageIndex);
    }

    return shouldShow;

  }

  showtransportSection(pageIndex) {
    // If hiding temporarily for remount, return false (hide section)
    this.showAdmissionDischargeDates(pageIndex);
    if (this.hideTransportSectionForRemount[pageIndex]) {
      return false;
    }

    var isBlockTreatment = this.getIsBlockTreatementControl()?.value;
    var claimType = this.getClaimTypesControl(pageIndex)?.value;
    
    let shouldShow = false;
    
    if (isBlockTreatment == OPTION_SETS.yesNo.options.yes || pageIndex > 0) {
      shouldShow = true;
    } else {
      var claimTypeLowerCase = claimType?.toLowerCase();
      shouldShow = claimTypeLowerCase == OPTION_SETS.claimTypes.options.Transport.toLowerCase()
        || claimTypeLowerCase == OPTION_SETS.claimTypes.options.Both.toLowerCase();
    }

    // AC01: Populate transport date fields when section is shown
    if (shouldShow) {
      this.showAdmissionDischargeDates(pageIndex);
      this.populateTransportDateFieldsFromTreatment(pageIndex);
    }

    return shouldShow;
  }

  private registerCustomFormListners(event: DspxBaseFormComponent) {
    const formGroup = this.baseForm.form.controls.form as FormGroup;
    var patientDropdown = this.getPatientSelectionDropdown(formGroup);

    patientDropdown?.valueChanges.subscribe(() => {
      var selectedPatient = this.patientOptions.find(x => x.Id.toLowerCase() == patientDropdown.value?.toLowerCase());
      var formProfileSection = formGroup.get(`tabs.tab${NAV_TAB_NUMBERS.vptasApplication.applicant}.page${PAGE_NUMBERS.vptasApplicationForm.applicantProfile}.${SECTION_CODES.vptasApplicationForm.profile}`);
      var formProfileCardDetailsSection = formGroup.get(`tabs.tab${NAV_TAB_NUMBERS.vptasApplication.applicant}.page${PAGE_NUMBERS.vptasApplicationForm.applicantProfile}.${SECTION_CODES.vptasApplicationForm.profileCardDetails}`);
      var formAddressSection = formGroup.get(`tabs.tab${NAV_TAB_NUMBERS.vptasApplication.applicant}.page${PAGE_NUMBERS.vptasApplicationForm.applicantProfile}.${SECTION_CODES.vptasApplicationForm.address}`);

      if (selectedPatient != null) {
        formProfileSection.patchValue({
          firstName: selectedPatient.FirstName,
          lastName: selectedPatient.LastName,
          middleName: selectedPatient.MiddleName,
          gender: selectedPatient.GenderId,
          dateOfBirth: selectedPatient.DateOfBirth != null ? this.dateUtil.formatToUIDateTimeFormat(new Date(selectedPatient.DateOfBirth)) : null, //02/09/2025
          mobilePhone: selectedPatient.MobilePhone,
          otherPhone: selectedPatient.OtherPhone,
          email: selectedPatient.Email,
          aboriginalOrTorresStraitIslanderDescent: selectedPatient.AboriginalOrTorresStraitIslanderDescentId,
          relationshipToPatient: selectedPatient.RelationshipToPatientId
        }, { emitEvent: true });

        formProfileCardDetailsSection.patchValue({
          profileCentrelinkCardNumber: selectedPatient.CentrelinkCardNumber,
          profileVeteransAffairsFileNumber: selectedPatient.VeteransAffairsCardNumber
        }, { emitEvent: true });

        formAddressSection.patchValue({
          ["primaryAddress"]: selectedPatient.ResidentialAddressAuto,
          ["primaryAddress-manualAddress"]: selectedPatient.ManualAddressResidential
        }, { emitEvent: true });
        if (selectedPatient.ManualAddressResidential) {
          setTimeout(() => {
            formAddressSection.patchValue({
              ["primaryAddress-manualAddress"]: selectedPatient.ManualAddressResidential,
              ["primaryAddress-streetNumberName"]: selectedPatient.ResidentialAddressManualStreetNumberName,
              ["primaryAddress-suburb"]: selectedPatient.ResidentialAddressManualSuburb,
              ["primaryAddress-state"]: selectedPatient.ResidentialAddressManualState,
              ["primaryAddress-postCode"]: selectedPatient.ResidentialAddressManualPostCode
            }, { emitEvent: true });
            this.defaultFirstTransportLocationsFromResidential();
          }, 100);
        } else {
          setTimeout(() => {
            this.defaultFirstTransportLocationsFromResidential();
          }, 0);
        }
      }
      else {
        formProfileSection.reset(null, { emitEvent: false });
        formProfileCardDetailsSection.reset(null, { emitEvent: false });
      }
    });


    this.subscribeToTreatmentLocationControl();
    this.subscribeToPatientDateOfBirth();
    this.subscribeToTransportModeChanges();

  }

  currentTreatmentLocation = null
  currentTreatmentLocationLatitude = null
  currentTreatmentLocationLongitude = null
  treatmentLocationSubscription: Subscription;
  private subscribeToTreatmentLocationControl() {
    const formGroup = this.baseForm.form.controls.form as FormGroup;
    const approvedSpecialistPath = `tabs.tab${NAV_TAB_NUMBERS.vptasApplication.travelAndAccommodation}.page${PAGE_NUMBERS.vptasApplicationForm.travelAndAccommodation}.0.${SECTION_CODES.vptasApplicationForm.approvedSpecialistService}`;
    const destinationQuestionCode = QUESTION_CODES.vptasApplicationForm.treatmentLocation;
    var treatmentLocationControl = formGroup.get(`${approvedSpecialistPath}.${destinationQuestionCode}`);

    if (treatmentLocationControl) {
      if (this.treatmentLocationSubscription && !this.treatmentLocationSubscription.closed) {
        this.treatmentLocationSubscription.unsubscribe();
      }

      this.treatmentLocationSubscription = treatmentLocationControl.valueChanges.subscribe((value) => {
        const approvedSpecialistModel = formGroup.get(approvedSpecialistPath)?.value;
        const destination = approvedSpecialistModel?.[destinationQuestionCode] ?? value ?? null;
        const destinationLatitude = approvedSpecialistModel?.[`${destinationQuestionCode}-autoLatitude`] ?? null;
        const destinationLongitude = approvedSpecialistModel?.[`${destinationQuestionCode}-autoLongitude`] ?? null;

        const hasChanged = destination !== this.currentTreatmentLocation;

        if (!hasChanged) {
          return;
        }

        if (destination == null || destinationLatitude == null || destinationLongitude == null) {
          return;
        }

        this.getIsDistanceEligibleForBlockTreatment(
          destination,
          destinationLatitude,
          destinationLongitude
        );

        this.currentTreatmentLocation = destination;
        this.currentTreatmentLocationLatitude = destinationLatitude;
        this.currentTreatmentLocationLongitude = destinationLongitude;
      });
    }
  }

  isBlockTreatmentValueChangesSubscription: Subscription;
  isMultipleModesSubscriptions: { [pageIndex: number]: Subscription } = {};
  patientDobSubscription: Subscription;
  transportModeSubscriptions: { [key: string]: Subscription } = {};

  private subscribeToIsBlockTreatment() {
    var isBlockTreatmentInput = this.getIsBlockTreatementControl();
    if (isBlockTreatmentInput == null) {
      return;
    }

    if (this.isBlockTreatmentValueChangesSubscription != null && !this.isBlockTreatmentValueChangesSubscription.closed) {
      this.isBlockTreatmentValueChangesSubscription.unsubscribe();
    }

    this.isBlockTreatmentValueChangesSubscription = isBlockTreatmentInput?.valueChanges.subscribe((value) => {
      var tripDetailsPages: any = this.getTravelAndAccomdationPages();
      var tripDetailsZeroSection = this.getApprovedSpecialistSection(0);
      if (tripDetailsPages == null || tripDetailsZeroSection == null) {
        return;
      }

      if (value == OPTION_SETS.yesNo.options.no && tripDetailsPages.length > 1) {
        this.activeDialog = POP_UP_CODES.victorianPatientTransportAssistanceScheme.blockTreatmentRemoveWarning;
        this.dialogService.showDialog(this.activeDialog);
        setTimeout(() => {
          tripDetailsZeroSection.patchValue({
            isBlockTreatment: OPTION_SETS.yesNo.options.yes,
          }, { emitEvent: true });
        });
      }
      else if (value == OPTION_SETS.yesNo.options.no && this.isDistanceEligibleForBlockTreatment && !this.isDistanceWithinExceptionThreashold) {
        this.activeDialog = POP_UP_CODES.victorianPatientTransportAssistanceScheme.confirmDistanceEligibility;
        this.dialogService.showDialog(this.activeDialog);
      }
      else {
        var tripDetailsPages: any = this.updateAddBlockAvailability(value == OPTION_SETS.yesNo.options.yes);
      }
    });
  }

  private getApprovedSpecialistSection(pageIndex: number) {
    return this.baseForm.form.controls.form.get(`tabs.tab${NAV_TAB_NUMBERS.vptasApplication.travelAndAccommodation}.page${PAGE_NUMBERS.vptasApplicationForm.travelAndAccommodation}.${pageIndex}.${SECTION_CODES.vptasApplicationForm.approvedSpecialistService}`);
  }

  private updateAddBlockAvailability(isBlock: boolean) {
    var tripDetailsPages: any = this.getTravelAndAccomdationPages();
    (tripDetailsPages as any)._fields[0].props.repeatingLimit = isBlock ? this.MAX_BLOCK_TREATMENT_ITEMS : 1;
    return tripDetailsPages;
  }

  private setTransportRepeatingLimit(pageIndex: number, isMultiMode: boolean): void {
    try {
      const formGroup = this.baseForm.form.controls.form as FormGroup;
      const pageCfg: any = this.getTravelAndAccomdationPage(pageIndex);
      const root = pageCfg?._fields?.[0];
      if (root?.fieldGroup?.length) {
        const transportIdx = root.fieldGroup.findIndex((x: any) => x?.key == SECTION_CODES.vptasApplicationForm.transportDetails);
        const transportField = transportIdx >= 0 ? root.fieldGroup[transportIdx] : null;
       
        if (transportField?.props) {
          transportField.props.repeatingLimit = isMultiMode ? this.MAX_TRANSPORT_MODE_ITEMS : 1;
          if (isMultiMode && transportField.props.extends) {
            transportField.props.disabled = false;
          }
          return;
        }
      }

      // Fallback: legacy path if transport section field lookup fails
      const tripDetailsPageAlt: any = formGroup.get(`tabs.tab${NAV_TAB_NUMBERS.vptasApplication.travelAndAccommodation}.page${PAGE_NUMBERS.vptasApplicationForm.transportDetails}`);
      if ((tripDetailsPageAlt as any)?._fields?.[0]?.props) {
        (tripDetailsPageAlt as any)._fields[0].props.repeatingLimit = isMultiMode ? this.MAX_TRANSPORT_MODE_ITEMS : 1;
        if (isMultiMode && (tripDetailsPageAlt as any)._fields[0].props.extends) {
          (tripDetailsPageAlt as any)._fields[0].props.disabled = false;
        }
      }
    } catch { /* no-op */ }
  }

  private getTravelAndAccomdationPages(): any {
    return (this.baseForm.form.controls.form as FormGroup).get(`tabs.tab${NAV_TAB_NUMBERS.vptasApplication.travelAndAccommodation}.page${PAGE_NUMBERS.vptasApplicationForm.travelAndAccommodation}`);
  }

  private getTravelAndAccomdationPage(pageIndex): any {
    return (this.baseForm.form.controls.form as FormGroup).get(`tabs.tab${NAV_TAB_NUMBERS.vptasApplication.travelAndAccommodation}.page${PAGE_NUMBERS.vptasApplicationForm.travelAndAccommodation}.${pageIndex}`);
  }

  private subscribeToIsMultipleModes(itemIndex: number, onComplete: (cancel: boolean) => void): void {
    try {
      const formGroup = this.baseForm.form.controls.form as FormGroup;
      const pageIndex = itemIndex;
      if (!formGroup) { onComplete(false); return; }

      const isMultipleModesControl = formGroup.get(
        `tabs.tab${NAV_TAB_NUMBERS.vptasApplication.travelAndAccommodation}.page${PAGE_NUMBERS.vptasApplicationForm.travelAndAccommodation}.${pageIndex}.${SECTION_CODES.vptasApplicationForm.approvedSpecialistService}.${QUESTION_CODES.vptasApplicationForm.isMultipleModes}`
      );

      if (!isMultipleModesControl) {
        this.setTransportRepeatingLimit(pageIndex, true);
        onComplete(false); return;
      }

      // Apply initial state
      const initialIsMulti = isMultipleModesControl.value === OPTION_SETS.yesNo.options.yes;
      this.setTransportRepeatingLimit(pageIndex, initialIsMulti);

      // Manage per-index subscription to avoid duplicates
      const prev = this.isMultipleModesSubscriptions?.[pageIndex];
      if (prev && !prev.closed) { prev.unsubscribe(); }

      this.isMultipleModesSubscriptions[pageIndex] = (isMultipleModesControl.valueChanges as any).subscribe((value: any) => {
        const isYes = value === OPTION_SETS.yesNo.options.yes;

        // Get the transport details section to check how many rows exist
        const pageArray: any = formGroup.get(`tabs.tab${NAV_TAB_NUMBERS.vptasApplication.travelAndAccommodation}.page${PAGE_NUMBERS.vptasApplicationForm.travelAndAccommodation}`);
        const pageCtrl = pageArray?.controls?.[pageIndex];
        const transportSection = pageCtrl?.controls?.[SECTION_CODES.vptasApplicationForm.transportDetails];
        // Count the number of transport entries
        const transportCount = Array.isArray(transportSection?.controls) ? transportSection.controls.length : 0;

        // If user is trying to change from Yes to No, but there are 2 or more transport rows, prevent it
        if (!isYes && transportCount >= 2) {
          this.activeDialog = POP_UP_CODES.victorianPatientTransportAssistanceScheme.multipleModesRemoveWarning;
          this.dialogService.showDialog(this.activeDialog);
          // Revert the value back to Yes
          setTimeout(() => {
            isMultipleModesControl.patchValue(OPTION_SETS.yesNo.options.yes, { emitEvent: false });
          });
          return;
        }

        this.setTransportRepeatingLimit(pageIndex, isYes);
      });

      onComplete(false);
    } catch {
      onComplete(false);
    }
  }

  private registerOnNavigation() {
       this.formNavSubscription =
        this.formNavigationService.onNavigation()
          .pipe(
            bufferTime(200),
            filter(x => x.length > 0)
          )
          .subscribe(async (data) => {

            let tabNumber = data.find(x => x.elementType === ElementType.TAB)?.elementNumber
            let pageNumber = data.find(x => x.elementType === ElementType.PAGE)?.elementNumber

            if (!this._hasAppliedInitialApplicantStep) {
              const stepTwoTab = NAV_TAB_NUMBERS.vptasApplication.applicant;
              const stepTwoPage = PAGE_NUMBERS.vptasApplicationForm.applicantProfile;
              this._hasAppliedInitialApplicantStep = true;

              if (tabNumber == stepTwoTab && pageNumber == stepTwoPage) {
                this.setCurrentTabAndPage(stepTwoTab, stepTwoPage);
                return;
              }

              this.setActiveTabAndPage(stepTwoTab, stepTwoPage);
              this.setCurrentTabAndPage(stepTwoTab, stepTwoPage);
              return;
            }

            if (this.coreService.isFormEditable === true) {

              // Prevent users from skipping steps when the form is editable
              if (tabNumber > this._currentTab + 1) {
                this.stayInCurrentTabAndPage();
                return;
              }

              // If the user is navigating forwards
              if (tabNumber > this._currentTab) {
                const formGroup = this.baseForm.form.controls.form as FormGroup;

                if (this._currentPage == PAGE_NUMBERS.vptasApplicationForm.preAppQuestionnaire
                  && this._currentTab == NAV_TAB_NUMBERS.vptasApplication.preAppQuestionnaire) {

                  var control = formGroup.get(`tabs.tab${NAV_TAB_NUMBERS.vptasApplication.preAppQuestionnaire}.page${PAGE_NUMBERS.vptasApplicationForm.preAppQuestionnaire}.${SECTION_CODES.vptasApplicationForm.preAppQuestionnaire}.${QUESTION_CODES.vptasApplicationForm.preAppQuestionnaireMultiCheckbox}`);
                  if (control.value == null || (control as any)._fields[0].props.options.length != control.value.length) {
                    this.stayInCurrentTabAndPage();
                    this.setPreAppQuestionnaireValidationErrorMessages(control);
                    return;
                  }
                  else if ((pageNumber == PAGE_NUMBERS.vptasApplicationForm.travelAndAccommodation
                    && tabNumber == NAV_TAB_NUMBERS.vptasApplication.travelAndAccommodation)
                    && !this.isPatientSpecified(formGroup)) {
                    this.setActiveTabAndPage(NAV_TAB_NUMBERS.vptasApplication.applicant, PAGE_NUMBERS.vptasApplicationForm.applicantProfile);
                    return;
                  }
                  else {
                    this.setCurrentTabAndPage(tabNumber, pageNumber);
                  }

                }
                else if (this._currentPage == PAGE_NUMBERS.vptasApplicationForm.applicantProfile
                  && this._currentTab == NAV_TAB_NUMBERS.vptasApplication.applicant) {
                  this.saveOnNavigation(this._currentTab);
                  this.setCurrentTabAndPage(tabNumber, pageNumber);
                }
                else if (this._currentPage == PAGE_NUMBERS.vptasApplicationForm.travelAndAccommodation
                  && this._currentTab == NAV_TAB_NUMBERS.vptasApplication.travelAndAccommodation) {
                  if (this.saveOnNavigation(this._currentTab)) {
                    this.setCurrentTabAndPage(tabNumber, pageNumber);
                  } else {
                    this.stayInCurrentTabAndPage();
                  }                  
                }
              }
              else {
                this.setCurrentTabAndPage(tabNumber, pageNumber);
              }
            }

          });
  }
  
  private setActiveTabAndPage(tabNumber, pageNumber) {
    this.formNavigationService.setActiveNumber(ElementType.TAB, tabNumber);
    this.formNavigationService.setActiveNumber(ElementType.PAGE, pageNumber);
  }

  private isPatientSpecified(formGroup: FormGroup<any>) {
    let patientSelectionDropdown = this.getPatientSelectionDropdown(formGroup);
    return patientSelectionDropdown.value != null;
  }

  private setPreAppQuestionnaireValidationErrorMessages(control: AbstractControl<any, any>) {
    (control as any).errors = { allCheckeboxesRequired: { message: null } };
    const validators = control?.validator ? [control.validator, multiCheckboxAllRequiredValidator] : [multiCheckboxAllRequiredValidator];
    control?.setValidators(validators);
    control?.updateValueAndValidity();
    this.baseForm.showValidationSummary(true);
    this.baseForm.markAllFieldsAsTouched();
  }

  private stayInCurrentTabAndPage() {
    this.formNavigationService.setActiveNumber(ElementType.TAB, this._currentTab);
    this.formNavigationService.setActiveNumber(ElementType.PAGE, this._currentPage);
  }

  private setCurrentTabAndPage(tabNumber: number, pageNumber: number) {
    this._currentTab = tabNumber ?? this._currentTab;
    this._currentPage = pageNumber ?? this._currentTab;
  }

  async checkCentrelinkCard(request): Promise<CentrelinkCardCheckResponse> {
    this.spinnerService.showSpinner();
    return await this.appDataService
      .post(API_ENDPOINTS.concessionApplication.centrelinkCardCheck, request)
      .pipe(
        take(1),
        this.errorService.errorHandler(),
        finalize(() => this.spinnerService.hideSpinner())
      ).toPromise();
  }

  showBlockTreatment(pageIndex) {
    var isBlockTreatmentControl = this.getIsBlockTreatementControl();
    var isManualAddress = this.getFirstTreatmentAddressIsManualAddressControl()?.value == true;
    return pageIndex == 0 && (isBlockTreatmentControl?.value != null || (this.isDistanceEligibleForBlockTreatment && this.isDistanceWithinExceptionThreashold == false));
  }

  showTreatmentDates(pageIndex) {
    var isBlockTreatmentControl = this.getIsBlockTreatementControl();
    return isBlockTreatmentControl?.value != null && isBlockTreatmentControl.value == OPTION_SETS.yesNo.options.yes;
  }

  showClaimTypes(pageIndex) {
    var isBlockTreatmentControl = this.getIsBlockTreatementControl();
    var val = isBlockTreatmentControl?.value;
    return pageIndex == 0 && (val == null || val == "no");
  }

  saveOnNavigation(tabNumber: number): boolean {
      if (!this.validateProviderPaymentIfFinancialInstitution()) {
        this.activeDialog = POP_UP_CODES.bankDetail.noFinancialInstitutionProviderPaymentConfirmation;
        this.dialogService.showDialog(this.activeDialog);
        return false;
      }
      if (this.isDraftApplication) {
        // Support composite id in the format "<applicationId>/<personId>"
        const { appId, personId, vptasApplicationSource, vptasApplicationSourceDate } = this.parseCompositeId(this.id);
        const saveDataRequest: VptasApplicationSaveDataRequest & {
          vptasApplicationSource?: string;
          vptasApplicationSourceDate?: string;
        } = {
          template: this.templateId,
          versionNumber: this.versionNo,
          id: appId,
          response: JSON.stringify(this.baseForm.model),
          expectedLastUpdateTime: (this.baseForm.lastUpdatedTime != null && this.baseForm.lastUpdatedTime !== '') ? this.baseForm.lastUpdatedTime : null,
          isSubmit: false,
          tabNumber: tabNumber,
          personId: personId,
          vptasApplicationSource: vptasApplicationSource,
          vptasApplicationSourceDate: vptasApplicationSourceDate
        };

        this.saveData(saveDataRequest);
       }
      return true;
  }

  isDistanceEligibleForBlockTreatment = false;
  isDistanceWithinExceptionThreashold = false;
  getIsDistanceEligibleForBlockTreatment(destination, destinationLatitude = null, destinationLongitude = null) {

    this.spinnerService.showSpinner();
    const requestPayload = {
      destination: destination ?? null,
      destinationLatitude: destinationLatitude ?? null,
      destinationLongitude: destinationLongitude ?? null
    };
    this.appDataService.post(`VictorianPatientTransportAssistanceSchemeApplication/${this.id}/IsDistanceEligibleForBlockTreatment`, requestPayload)
      .pipe(
        take(1),
        this.errorService.errorHandler(),
        finalize(() => this.spinnerService.hideSpinner())
      )
      .subscribe({
        next: (result) => {
          this.isDistanceEligibleForBlockTreatment = result.isDistanceEligibleForBlockTreatment;
          this.isDistanceWithinExceptionThreashold = result.isDistanceWithinExceptionThreashold;
          var firstTravelAndAccomdationPage = this.getTravelAndAccomdationPage(0);
          var specialistServiceFieldGroupindex = firstTravelAndAccomdationPage._fields[0].fieldGroup.findIndex(x => x.key == SECTION_CODES.vptasApplicationForm.approvedSpecialistService);
          var isBlockTreatmentFieldIndex = firstTravelAndAccomdationPage._fields[0].fieldGroup[specialistServiceFieldGroupindex].fieldGroup.findIndex(x => x.key == QUESTION_CODES.vptasApplicationForm.isBlockTreatment);
          var isBlockTreatmentField = firstTravelAndAccomdationPage._fields[0].fieldGroup[specialistServiceFieldGroupindex].fieldGroup[isBlockTreatmentFieldIndex];
          isBlockTreatmentField.options.checkExpressions(isBlockTreatmentField);

          if (this.isDistanceEligibleForBlockTreatment) {
            this.subscribeToIsBlockTreatment();
          }
        },
        error: (error) => {
          console.error('Distance calculation error:', error);
        }
      });
  }

  showMultipleModes(pageIndex) {
    const formGroup = this.baseForm.form.controls.form as FormGroup;
    const tripDetailsPage: any = formGroup.get(
      `tabs.tab${NAV_TAB_NUMBERS.vptasApplication.travelAndAccommodation}.page${PAGE_NUMBERS.vptasApplicationForm.travelAndAccommodation}`
    );
    if (!tripDetailsPage) return false;

    const claimTypesControl =
      tripDetailsPage?.controls?.[pageIndex]?.controls?.approvedSpecialistService?.controls?.claimTypes;

    const value = (claimTypesControl?.value ?? '').toString().toLowerCase();
    const both = OPTION_SETS.claimTypes.options.Both.toLowerCase();
    const transport = OPTION_SETS.claimTypes.options.Transport.toLowerCase();
    return value === both || value === transport;
  }

  showNumberOfNightsApprovedBySpecialists(pageIndex) {
    const claimTypesControl = this.getClaimTypesControl(pageIndex);
    const allowedOptions = [
      OPTION_SETS.claimTypes.options.Accommodation.toLowerCase(),
      OPTION_SETS.claimTypes.options.Both.toLowerCase()
    ];
    return claimTypesControl != null ? allowedOptions.includes(claimTypesControl.value?.toLowerCase()) : false;
  }

  showStartEndLocation(sectionIndex) {
    const formGroup = this.baseForm.form.controls.form as FormGroup;
    var isMultipleModesControl = formGroup.get(`tabs.tab${NAV_TAB_NUMBERS.vptasApplication.travelAndAccommodation}.page${PAGE_NUMBERS.vptasApplicationForm.travelAndAccommodation}.0.${SECTION_CODES.vptasApplicationForm.approvedSpecialistService}.${QUESTION_CODES.vptasApplicationForm.isMultipleModes}`);
    if (isMultipleModesControl?.value == OPTION_SETS.yesNo.options.yes) {
      this.defaultFirstTransportLocationsFromResidential();
      return true;
    }
    return false;
  }

  private defaultFirstTransportLocationsFromResidential(): void {
    try {
      const formGroup = this.baseForm?.form?.controls?.form as FormGroup;
      if (!formGroup) { return; }

      const applicantTab = NAV_TAB_NUMBERS.vptasApplication.applicant;
      const applicantPage = PAGE_NUMBERS.vptasApplicationForm.applicantProfile;
      const travelTab = NAV_TAB_NUMBERS.vptasApplication.travelAndAccommodation;
      const travelPage = PAGE_NUMBERS.vptasApplicationForm.travelAndAccommodation;

      const tripDetailsPage: any = formGroup.get(`tabs.tab${travelTab}.page${travelPage}`);
      if (!tripDetailsPage?.controls || tripDetailsPage.length < 1) { return; }

      const firstIndex = 0;

      const addressAuto = formGroup.get(`tabs.tab${applicantTab}.page${applicantPage}.${SECTION_CODES.vptasApplicationForm.address}.primaryAddress`);
      const addressManualFlag = formGroup.get(`tabs.tab${applicantTab}.page${applicantPage}.${SECTION_CODES.vptasApplicationForm.address}.primaryAddress-manualAddress`);
      const addressStreet = formGroup.get(`tabs.tab${applicantTab}.page${applicantPage}.${SECTION_CODES.vptasApplicationForm.address}.primaryAddress-streetNumberName`);
      const addressSuburb = formGroup.get(`tabs.tab${applicantTab}.page${applicantPage}.${SECTION_CODES.vptasApplicationForm.address}.primaryAddress-suburb`);
      const addressState = formGroup.get(`tabs.tab${applicantTab}.page${applicantPage}.${SECTION_CODES.vptasApplicationForm.address}.primaryAddress-state`);
      const addressPostCode = formGroup.get(`tabs.tab${applicantTab}.page${applicantPage}.${SECTION_CODES.vptasApplicationForm.address}.primaryAddress-postCode`);

      const setIfEmpty = (path: string, value: any) => {
        const ctrl = formGroup.get(path);
        if (!ctrl) { return; }
        const current = (ctrl as any).value;
        if (current === null || current === undefined || current === '') {
          (ctrl as any).patchValue(value, { emitEvent: true });
        }
      };

      // Target the first transportDetails item inside the transportDetails section (index 0)
      const baseStart = `tabs.tab${travelTab}.page${travelPage}.${firstIndex}.${SECTION_CODES.vptasApplicationForm.transportDetails}.0`;

      const autoVal = addressAuto?.value;
      const manualFlag = addressManualFlag?.value;
      const approvedSpecialistPath = `tabs.tab${travelTab}.page${travelPage}.0.${SECTION_CODES.vptasApplicationForm.approvedSpecialistService}`;
      const approvedSpecialistModel = formGroup.get(approvedSpecialistPath)?.value;
      const treatmentLocationControl = formGroup.get(
        `tabs.tab${travelTab}.page${travelPage}.0.${SECTION_CODES.vptasApplicationForm.approvedSpecialistService}.${QUESTION_CODES.vptasApplicationForm.treatmentLocation}`
      );
      const treatmentLocationVal = treatmentLocationControl?.value;
      const treatmentLocationLatitude = approvedSpecialistModel?.['approvedSpecialistServiceTreatmentLocation-autoLatitude'] ?? approvedSpecialistModel?.[`${QUESTION_CODES.vptasApplicationForm.treatmentLocation}-autoLatitude`] ?? null;
      const treatmentLocationLongitude = approvedSpecialistModel?.['approvedSpecialistServiceTreatmentLocation-autoLongitude'] ?? approvedSpecialistModel?.[`${QUESTION_CODES.vptasApplicationForm.treatmentLocation}-autoLongitude`] ?? null;

      if (manualFlag === true) {
        setIfEmpty(`${baseStart}.transportDetailsStartLocation-manualAddress`, manualFlag);
        setIfEmpty(`${baseStart}.transportDetailsStartLocation-streetNumberName`, addressStreet?.value ?? '');
        setIfEmpty(`${baseStart}.transportDetailsStartLocation-suburb`, addressSuburb?.value ?? '');
        setIfEmpty(`${baseStart}.transportDetailsStartLocation-state`, addressState?.value ?? '');
        setIfEmpty(`${baseStart}.transportDetailsStartLocation-postCode`, addressPostCode?.value ?? '');
      }
      else {
        setIfEmpty(`${baseStart}.transportDetailsStartLocation`, autoVal);
      }
      if (treatmentLocationVal !== null && treatmentLocationVal !== undefined && treatmentLocationVal !== '') {
        setIfEmpty(`${baseStart}.transportDetailsEndLocation`, treatmentLocationVal);
        if (treatmentLocationLatitude !== null && treatmentLocationLatitude !== undefined && treatmentLocationLatitude !== '') {
          setIfEmpty(`${baseStart}.transportDetailsEndLocation-autoLatitude`, treatmentLocationLatitude);
        }
        if (treatmentLocationLongitude !== null && treatmentLocationLongitude !== undefined && treatmentLocationLongitude !== '') {
          setIfEmpty(`${baseStart}.transportDetailsEndLocation-autoLongitude`, treatmentLocationLongitude);
        }
      }
    } catch (err) {
      console.warn('Defaulting first transport locations failed', err);
    }
  }

  private setCurrentTreatementLocation() {
    setTimeout(() => {
      var treatmentLocationControl = this.baseForm.form.controls.form.get(`tabs.tab${NAV_TAB_NUMBERS.vptasApplication.travelAndAccommodation}.page${PAGE_NUMBERS.vptasApplicationForm.travelAndAccommodation}.0.${SECTION_CODES.vptasApplicationForm.approvedSpecialistService}.${QUESTION_CODES.vptasApplicationForm.treatmentLocation}`);
      this.currentTreatmentLocation = treatmentLocationControl?.value;
    });
  }

  private updateAddBlockAvailabilityBasedOnIsBlockTreatmentQuestion() {
    setTimeout(() => {
      var isBlockTreatment = this.getIsBlockTreatementControl();
      this.updateAddBlockAvailability(isBlockTreatment != null && isBlockTreatment.value == OPTION_SETS.yesNo.options.yes);
    });
  }

  private showtransportDetailsDocumentsValidationMessage(pageSectionIndex) {
    if (pageSectionIndex == null) {
      return false;
    }
    const [pageIndex, sectionIndex] = this.getPageAndSectionIndex(pageSectionIndex);
    const transportDocumentList = this.getTransportDocumentsList(pageIndex, sectionIndex);
    return transportDocumentList?.touched && transportDocumentList?.status == "INVALID";
  }

  private IsTransportDetailsTransportTypeValid(pageAndSectionIndex) {
    const [pageIndex, sectionIndex] = this.getPageAndSectionIndex(pageAndSectionIndex);
    var transportDetailsTransportType = this.getTransportDetailsTransportType(pageIndex, sectionIndex)?.value;
    const allowedTransportModesForBlockTreatment = [OPTION_SETS.transportMode.options.cartravel.toLowerCase(), OPTION_SETS.transportMode.options.publictransport.toLowerCase()];
    return !this.getIsBlockTreatement() || allowedTransportModesForBlockTreatment.includes(transportDetailsTransportType?.toLowerCase());
  }

  private IsTransportDetailsTypeOfCarTravelValid(pageAndSectionIndex) {
    const [pageIndex, sectionIndex] = this.getPageAndSectionIndex(pageAndSectionIndex);
    var transportDetailsTypeOfCarTravel = this.getTransportDetailsTypeOfCarTravel(pageIndex, sectionIndex)?.value;
    const allowedTransportModesForBlockTreatment = [OPTION_SETS.typeOfTravel.options.privateCar.toLowerCase(), OPTION_SETS.typeOfTravel.options.communityTransport.toLowerCase()];
    return !this.getIsBlockTreatement() || allowedTransportModesForBlockTreatment.includes(transportDetailsTypeOfCarTravel?.toLowerCase());
  }

  private getTransportDocumentsList(pageIndex, sectionIndex) {
    return (this.baseForm.form.controls.form as FormGroup).get(`tabs.tab${NAV_TAB_NUMBERS.vptasApplication.travelAndAccommodation}.page${PAGE_NUMBERS.vptasApplicationForm.travelAndAccommodation}.${pageIndex}.${SECTION_CODES.vptasApplicationForm.transportDetails}.${sectionIndex}.${QUESTION_CODES.vptasApplicationForm.transportDetailsDocuments}`);
  }

  private showAccommodationDetailsDocumentsValidationMessage(pageSectionIndex) {
    if (pageSectionIndex == null) {
      return false;
    }
    const [pageIndex, sectionIndex] = this.getPageAndSectionIndex(pageSectionIndex);
    const accommodationDocumentList = this.getAccommodationDocumentsList(pageIndex, sectionIndex);
    return accommodationDocumentList?.touched && accommodationDocumentList?.status == "INVALID";
  }

  private getAccommodationDocumentsList(pageIndex, sectionIndex) {
    return (this.baseForm.form.controls.form as FormGroup).get(`tabs.tab${NAV_TAB_NUMBERS.vptasApplication.travelAndAccommodation}.page${PAGE_NUMBERS.vptasApplicationForm.travelAndAccommodation}.${pageIndex}.${SECTION_CODES.vptasApplicationForm.accommodationDetails}.${sectionIndex}.${QUESTION_CODES.vptasApplicationForm.accommodationDetailsDocuments}`);
  }

  private isMultipleModesSelected(pageIndex: number): boolean {
    try {
      const formGroup = this.baseForm?.form?.controls?.form as FormGroup;
      if (!formGroup && pageIndex !== 0) { return false; }
      const ctrl = formGroup.get(
        `tabs.tab${NAV_TAB_NUMBERS.vptasApplication.travelAndAccommodation}.page${PAGE_NUMBERS.vptasApplicationForm.travelAndAccommodation}.${pageIndex}.${SECTION_CODES.vptasApplicationForm.approvedSpecialistService}.${QUESTION_CODES.vptasApplicationForm.isMultipleModes}`
      );
      return ctrl?.value === OPTION_SETS.yesNo.options.yes;
    } catch {
      return false;
    }
  }

  private getTransportDetailsTransportType(pageIndex, sectionIndex) {
    return (this.baseForm.form.controls.form as FormGroup).get(`tabs.tab${NAV_TAB_NUMBERS.vptasApplication.travelAndAccommodation}.page${PAGE_NUMBERS.vptasApplicationForm.travelAndAccommodation}.${pageIndex}.${SECTION_CODES.vptasApplicationForm.transportDetails}.${sectionIndex}.${QUESTION_CODES.vptasApplicationForm.transportDetailsTransportType}`);
  }

  private getTransportDetailsTypeOfCarTravel(pageIndex, sectionIndex) {
    return (this.baseForm.form.controls.form as FormGroup).get(`tabs.tab${NAV_TAB_NUMBERS.vptasApplication.travelAndAccommodation}.page${PAGE_NUMBERS.vptasApplicationForm.travelAndAccommodation}.${pageIndex}.${SECTION_CODES.vptasApplicationForm.transportDetails}.${sectionIndex}.${QUESTION_CODES.vptasApplicationForm.transportDetailsTypeOfTravel}`);
  }

  private getTransportDetailsTypeOfPublicTravel(pageIndex, sectionIndex) {
    return (this.baseForm.form.controls.form as FormGroup).get(`tabs.tab${NAV_TAB_NUMBERS.vptasApplication.travelAndAccommodation}.page${PAGE_NUMBERS.vptasApplicationForm.travelAndAccommodation}.${pageIndex}.${SECTION_CODES.vptasApplicationForm.transportDetails}.${sectionIndex}.${QUESTION_CODES.vptasApplicationForm.transportDetailsTypeOfPublicTravel}`);
  }

  private getTransportDetailsTripType(pageIndex, sectionIndex) {
    return (this.baseForm.form.controls.form as FormGroup).get(`tabs.tab${NAV_TAB_NUMBERS.vptasApplication.travelAndAccommodation}.page${PAGE_NUMBERS.vptasApplicationForm.travelAndAccommodation}.${pageIndex}.${SECTION_CODES.vptasApplicationForm.transportDetails}.${sectionIndex}.${SECTION_CODES.vptasApplicationForm.transportDetailsTripType}`);
  }

  private isHospitalisedInfant(pageIndex: number = 0): boolean {
    const formGroup = this.baseForm?.form?.controls?.form as FormGroup;
    if (!formGroup) { return false; }

    const patientAgeInDays = this.getPatientAgeInDays(pageIndex);
    const ageCategory = this.getAgeCategory(patientAgeInDays);

    // Check if patient is an infant
    if (ageCategory !== VPTAS_AGE_CATEGORIES.infant) {
      return false;
    }

    // Check if hospital admission is yes
    const hospitalAdmissionControl = formGroup.get(
      `tabs.tab${NAV_TAB_NUMBERS.vptasApplication.travelAndAccommodation}.page${PAGE_NUMBERS.vptasApplicationForm.travelAndAccommodation}.0.${SECTION_CODES.vptasApplicationForm.approvedSpecialistService}.approvedSpecialistServiceIsHospitalAdmission`
    );

    const hospitalAdmissionValue = hospitalAdmissionControl?.value;
    return hospitalAdmissionValue === OPTION_SETS.yesNo.options.yes;
  }

  private getClaimTypesControl(pageIndex: any) {
    return (this.baseForm.form.controls.form as FormGroup).get(`tabs.tab${NAV_TAB_NUMBERS.vptasApplication.travelAndAccommodation}.page${PAGE_NUMBERS.vptasApplicationForm.travelAndAccommodation}.${pageIndex}.${SECTION_CODES.vptasApplicationForm.approvedSpecialistService}.${QUESTION_CODES.vptasApplicationForm.claimTypes}`);
  }

  private getIsBlockTreatementControl() {
    return (this.baseForm.form.controls.form as FormGroup).get(`tabs.tab${NAV_TAB_NUMBERS.vptasApplication.travelAndAccommodation}.page${PAGE_NUMBERS.vptasApplicationForm.travelAndAccommodation}.0.${SECTION_CODES.vptasApplicationForm.approvedSpecialistService}.${QUESTION_CODES.vptasApplicationForm.isBlockTreatment}`);
  }

  private getFirstTreatmentAddressIsManualAddressControl() {
    return (this.baseForm.form.controls.form as FormGroup).get(`tabs.tab${NAV_TAB_NUMBERS.vptasApplication.travelAndAccommodation}.page${PAGE_NUMBERS.vptasApplicationForm.travelAndAccommodation}.0.${SECTION_CODES.vptasApplicationForm.approvedSpecialistService}.${QUESTION_CODES.vptasApplicationForm.approvedSpecialistServiceTreatmentLocationManualAddress}`);
  }
  private getPatientSelectionDropdown(formGroup: FormGroup<any>) {
    return formGroup.get(`tabs.tab${NAV_TAB_NUMBERS.vptasApplication.applicant}.page${PAGE_NUMBERS.vptasApplicationForm.applicantProfile}.${SECTION_CODES.vptasApplicationForm.profile}.${QUESTION_CODES.vptasApplicationForm.selectPatient}`);
  }

  private getIsBlockTreatement() {
    return this.getIsBlockTreatementControl()?.value == OPTION_SETS.yesNo.options.yes;
  }

  private showTransportDetailsTripType() {
    return !this.getIsBlockTreatement();
  }

  private getPageAndSectionIndex(pageSectionIndex: any): [any, any] {
    return pageSectionIndex.toString().split(',').map(x => Number(x.trim()));
  }

  private toPageSectionIndex(page: number, section: number): string {
    return `${page}, ${section}`;
  }

  /**
   * Subscribe to patient date of birth changes to re-validate "Claim for" fields
   */
  private subscribeToPatientDateOfBirth(): void {
    const formGroup = this.baseForm?.form?.controls?.form as FormGroup;
    if (!formGroup) { return; }

    const dobControl = formGroup.get(
      `tabs.tab${NAV_TAB_NUMBERS.vptasApplication.applicant}.page${PAGE_NUMBERS.vptasApplicationForm.applicantProfile}.${SECTION_CODES.vptasApplicationForm.profile}.dateOfBirth`
    );

    if (dobControl) {
      if (this.patientDobSubscription && !this.patientDobSubscription.closed) {
        this.patientDobSubscription.unsubscribe();
      }

      this.patientDobSubscription = dobControl.valueChanges.subscribe(() => {
        // Trigger change detection for SP1/SP2 visibility
        this.cdr.detectChanges();
      });
    }
  }

  /**
   * Subscribe to transport mode changes in all transport detail items
   */
  private subscribeToTransportModeChanges(): void {
    const formGroup = this.baseForm?.form?.controls?.form as FormGroup;
    if (!formGroup) { return; }

    // Clean up existing subscriptions
    Object.values(this.transportModeSubscriptions).forEach(sub => {
      if (sub && !sub.closed) {
        sub.unsubscribe();
      }
    });
    this.transportModeSubscriptions = {};

    // Subscribe to transport mode changes for all pages and sections
    const pageArray: any = formGroup.get(
      `tabs.tab${NAV_TAB_NUMBERS.vptasApplication.travelAndAccommodation}.page${PAGE_NUMBERS.vptasApplicationForm.travelAndAccommodation}`
    );

    if (!pageArray?.controls) { return; }

    pageArray.controls.forEach((pageCtrl: any, pageIndex: number) => {
      const transportSection = pageCtrl?.controls?.[SECTION_CODES.vptasApplicationForm.transportDetails];
      if (!transportSection?.controls) { return; }

      transportSection.controls.forEach((transportItem: any, sectionIndex: number) => {
        const transportModeControl = transportItem?.controls?.[QUESTION_CODES.vptasApplicationForm.transportDetailsTypeOfTravel];
        if (transportModeControl) {
          const key = `${pageIndex}_${sectionIndex}`;

          if (this.transportModeSubscriptions[key] && !this.transportModeSubscriptions[key].closed) {
            this.transportModeSubscriptions[key].unsubscribe();
          }

          this.transportModeSubscriptions[key] = transportModeControl.valueChanges.subscribe(() => {
            // Trigger change detection for SP1/SP2 visibility
            this.cdr.detectChanges();
          });
        }
      });
    });
  }

  /**
   * Common helper: Get age category based on patient age in days
   * Returns: 'infant' (<= 180 days), 'child' (181 days to < 6570 days), 'adult' (>= 6570 days), or null if age unknown
   */
  private getAgeCategory(patientAgeInDays: number | null): string | null {
    if (patientAgeInDays === null) { return null; }
    if (patientAgeInDays <= VPTAS_AGE_THRESHOLDS.infantDays) { return VPTAS_AGE_CATEGORIES.infant; }
    if (patientAgeInDays < VPTAS_AGE_THRESHOLDS.adultDays) { return VPTAS_AGE_CATEGORIES.child; }
    return VPTAS_AGE_CATEGORIES.adult;
  }

  /**
   * Helper: Get "Claim for" value from form using pageAndSectionIndex
   * Tries both transport and accommodation sections
   */
  private getClaimForValueTransport(pageAndSectionIndex: any): any {
    const [pageIndex, sectionIndex] = this.getPageAndSectionIndex(pageAndSectionIndex);
    const formGroup = this.baseForm?.form?.controls?.form as FormGroup;
    if (!formGroup) { return null; }

    const pageArray: any = formGroup.get(
      `tabs.tab${NAV_TAB_NUMBERS.vptasApplication.travelAndAccommodation}.page${PAGE_NUMBERS.vptasApplicationForm.travelAndAccommodation}`
    );
    if (!pageArray?.controls || pageIndex >= pageArray.controls.length) { return null; }

    const pageCtrl = pageArray.controls[pageIndex];

    // Try transport details first
    const transportSection = pageCtrl?.controls?.[SECTION_CODES.vptasApplicationForm.transportDetails];
    if (transportSection?.controls && sectionIndex < transportSection.controls.length) {
      const transportItem = transportSection.controls[sectionIndex];
      const claimForControl = transportItem?.controls?.['transportDetailsClaimedFor'];
      if (claimForControl?.value) {
        return claimForControl.value;
      }
    }

    return null;
  }

  /**
     * Helper: Get "Claim for" value from form using pageAndSectionIndex
     * Tries both transport and accommodation sections
     */
  private getClaimForValueAccommodation(pageAndSectionIndex: any): any {
    const [pageIndex, sectionIndex] = this.getPageAndSectionIndex(pageAndSectionIndex);
    const formGroup = this.baseForm?.form?.controls?.form as FormGroup;
    if (!formGroup) { return null; }

    const pageArray: any = formGroup.get(
      `tabs.tab${NAV_TAB_NUMBERS.vptasApplication.travelAndAccommodation}.page${PAGE_NUMBERS.vptasApplicationForm.travelAndAccommodation}`
    );
    if (!pageArray?.controls || pageIndex >= pageArray.controls.length) { return null; }

    const pageCtrl = pageArray.controls[pageIndex];

    // Try accommodation details
    const accommodationSection = pageCtrl?.controls?.[SECTION_CODES.vptasApplicationForm.accommodationDetails];
    if (accommodationSection?.controls && sectionIndex < accommodationSection.controls.length) {
      const accommodationItem = accommodationSection.controls[sectionIndex];
      const claimForControl = accommodationItem?.controls?.['accommodationDetailsClaimedFor'];
      if (claimForControl?.value) {
        return claimForControl.value;
      }
    }

    return null;
  }

  /**
   * Helper: Get support person name values from form
   */
  private getSupportPersonNames(): { supportPersonNameOne: any; supportPersonNameTwo: any } {
    const formGroup = this.baseForm?.form?.controls?.form as FormGroup;
    if (!formGroup) { return { supportPersonNameOne: null, supportPersonNameTwo: null }; }

    const pageCtrl = formGroup.get(
      `tabs.tab${NAV_TAB_NUMBERS.vptasApplication.travelAndAccommodation}.page${PAGE_NUMBERS.vptasApplicationForm.travelAndAccommodation}.0`
    );

    if (!pageCtrl) { return { supportPersonNameOne: null, supportPersonNameTwo: null }; }

    const supportPersonOneSection = pageCtrl.get('supportPersonOneDetails');
    const supportPersonTwoSection = pageCtrl.get('supportPersonTwoDetails');

    const supportPersonNameOne = supportPersonOneSection?.get('supportPersonNameOne')?.value;
    const supportPersonNameTwo = supportPersonTwoSection?.get('supportPersonNameTwo')?.value;

    return {
      supportPersonNameOne: supportPersonNameOne || null,
      supportPersonNameTwo: supportPersonNameTwo || null
    };
  }

  private showSupportPersonInfantDeclaration(): boolean {
    // Get required values
    const patientAgeInDays = this.getPatientAgeInDays();
    const ageCategory = this.getAgeCategory(patientAgeInDays);

    // Check if support person names exist
    const { supportPersonNameOne, supportPersonNameTwo } = this.getSupportPersonNames();
    const hasSupportPersonNames = (supportPersonNameOne && supportPersonNameOne.toString().trim() !== '') ||
      (supportPersonNameTwo && supportPersonNameTwo.toString().trim() !== '');

    return ageCategory === VPTAS_AGE_CATEGORIES.infant && this.isHospitalisedInfant() && hasSupportPersonNames;
  }

  private showSupportPersonChildDeclaration(): boolean {
    // Get required values
    const patientAgeInDays = this.getPatientAgeInDays();
    const ageCategory = this.getAgeCategory(patientAgeInDays);

    // Check if support person names exist
    const { supportPersonNameOne, supportPersonNameTwo } = this.getSupportPersonNames();
    const hasSupportPersonNames = (supportPersonNameOne && supportPersonNameOne.toString().trim() !== '') ||
      (supportPersonNameTwo && supportPersonNameTwo.toString().trim() !== '');

    return (ageCategory === VPTAS_AGE_CATEGORIES.child || (ageCategory === VPTAS_AGE_CATEGORIES.infant && !this.isHospitalisedInfant())) && hasSupportPersonNames;
  }

  private showSupportPersonAdultDeclaration(): boolean {
    // Get required values
    const patientAgeInDays = this.getPatientAgeInDays();
    const ageCategory = this.getAgeCategory(patientAgeInDays);

    // Check if support person names exist
    const { supportPersonNameOne, supportPersonNameTwo } = this.getSupportPersonNames();
    const hasSupportPersonNames = (supportPersonNameOne && supportPersonNameOne.toString().trim() !== '') ||
      (supportPersonNameTwo && supportPersonNameTwo.toString().trim() !== '');

    return (ageCategory === VPTAS_AGE_CATEGORIES.adult) && hasSupportPersonNames;
  }

  showrelationshipToPatientIfNotAdult(): boolean {
    const patientAgeInDays = this.getPatientAgeInDays();
    const ageCategory = this.getAgeCategory(patientAgeInDays);
    return ageCategory !== VPTAS_AGE_CATEGORIES.adult;
  }

  showSupportPersonOneSectionAndRelationshipToPatient(pageIndex): boolean {
    return this.showSupportPersonOneSection(pageIndex) && this.showrelationshipToPatientIfNotAdult();
  }

  showSupportPersonTwoSectionAndRelationshipToPatient(pageIndex): boolean {
    return this.showSupportPersonTwoSection(pageIndex) && this.showrelationshipToPatientIfNotAdult();
  }

  /**
   * Unified validation method for all support scenarios
   * Checks if the selected "Claim for" value is allowed based on transport mode and patient age
   * Returns true if validation error should be shown (invalid), false if valid
   * 
   * Decision tree:
   * 1. Transport mode = Private/Community? → YES → only "Patient Only" allowed
   * 2. Age < 6 months? → YES → all options allowed (always valid)
   * 3. Age < 18 years (>= 6 months)? → YES → allowed (P/E/PE)
   * 4. Age >= 18? → allowed (P/E/PE)
   */
  private validateSupportScenarioTransport(pageAndSectionIndex: any, claimForValue?: any) {

    const [pageIndex, sectionIndex] = this.getPageAndSectionIndex(pageAndSectionIndex);

    // Get required values
    const transportModeValue = this.getTransportDetailsTypeOfCarTravel(pageIndex, sectionIndex)?.value;
    const patientAgeInDays = this.getPatientAgeInDays(pageIndex);

    // Get claimForValue if not provided
    if (claimForValue === undefined || claimForValue === null) {
      claimForValue = this.getClaimForValueTransport(pageAndSectionIndex);
    }

    // Let required validator handle empty values
    if (!claimForValue) {
      return true; // No validation error for empty values
    }

    const claimForValueStr = claimForValue.toString().toLowerCase();
    const patientOnlyId = VPTAS_CLAIM_FOR_IDS.patientOnly.toLowerCase();
    const escortOnlyId = VPTAS_CLAIM_FOR_IDS.escortOnly.toLowerCase();
    const patientAndEscortId = VPTAS_CLAIM_FOR_IDS.patientAndEscort.toLowerCase();
    const allowedPEPEIds = [patientOnlyId, escortOnlyId, patientAndEscortId];

    // Block treatment check: If block treatment is selected, only "Patient Only" is allowed
    if (this.getIsBlockTreatement()) {
      // Return true if "Patient Only" (valid), false otherwise (invalid)
      return (claimForValueStr === patientOnlyId);
    }

    // Get age category
    const ageCategory = this.getAgeCategory(patientAgeInDays);

    // Rule 2: Age < 6 months? → YES → all options allowed (always valid)
    if (ageCategory === VPTAS_AGE_CATEGORIES.infant) {
      // Rule for Hospitalised Infant: If "Escort Only", then only Drop-off or Pick-up allowed
      if (this.isHospitalisedInfant(pageIndex) && claimForValueStr === escortOnlyId) {
        const tripTypeControl = this.getTransportDetailsTripType(pageIndex, sectionIndex);
        const tripTypeValue = tripTypeControl?.value;
        if (tripTypeValue) {
          const tripTypeStr = tripTypeValue.toString().toLowerCase();
          const allowedTripTypes = [VPTAS_TRIP_TYPE_IDS.dropOff.toLowerCase(), VPTAS_TRIP_TYPE_IDS.pickUp.toLowerCase()];
          if (!allowedTripTypes.includes(tripTypeStr)) {
            return false; // Invalid trip type for Escort Only
          }
        }
      }
      return true; // All options allowed, no validation error
    }

    // Rule 3 & 4: Age < 18 years (>= 6 months) OR Age >= 18? → allowed (P/E/PE)
    if (ageCategory === VPTAS_AGE_CATEGORIES.child || ageCategory === VPTAS_AGE_CATEGORIES.adult) {
      // Special rule for children: If treatment is more than 2 consecutive days, support person 2 is allowed
      if (ageCategory === VPTAS_AGE_CATEGORIES.child) {
        const treatmentDuration = this.getTreatmentDurationInDays(pageIndex);
        if (treatmentDuration !== null && treatmentDuration >= 1) {
          // For children with treatment > 1 day, allow support person 2 options
          const patientAndTwoEscortsId = VPTAS_CLAIM_FOR_IDS.patientAndTwoEscorts.toLowerCase();
          const twoEscortsId = VPTAS_CLAIM_FOR_IDS.twoEscorts.toLowerCase();
          const allowedWithSP2 = [...allowedPEPEIds, patientAndTwoEscortsId, twoEscortsId];
          if (!allowedWithSP2.includes(claimForValueStr)) {
            return false; // Invalid claim for value
          }
        } else {
          // Return true if in allowed list [PatientOnly, EscortOnly, PatientAndEscort] (valid), false otherwise (invalid)
          if (!allowedPEPEIds.includes(claimForValueStr)) {
            return false; // Invalid claim for value
          }
        }
      } else {
        // Return true if in allowed list [PatientOnly, EscortOnly, PatientAndEscort] (valid), false otherwise (invalid)
        if (!allowedPEPEIds.includes(claimForValueStr)) {
          return false; // Invalid claim for value
        }
      }

      // Trip type validation: If "Escort Only" (Support Person - only), then only Drop-off or Pick-up allowed for Adult, Child, and Hospitalised Infant
      if (claimForValueStr === escortOnlyId) {
        const tripTypeControl = this.getTransportDetailsTripType(pageIndex, sectionIndex);
        const tripTypeValue = tripTypeControl?.value;
        if (tripTypeValue) {
          const tripTypeStr = tripTypeValue.toString().toLowerCase();
          const allowedTripTypes = [VPTAS_TRIP_TYPE_IDS.dropOff.toLowerCase(), VPTAS_TRIP_TYPE_IDS.pickUp.toLowerCase()];
          if (!allowedTripTypes.includes(tripTypeStr)) {
            return false; // Invalid trip type for Escort Only
          }
        }
      }
      return true; // Valid
    }

    // Default: If age is unknown, allow all (no validation error)    
    return true;//do not show validation error
  }

  private validateSupportScenarioAccommodation(pageAndSectionIndex: any, claimForValue?: any) {

    const [pageIndex, sectionIndex] = this.getPageAndSectionIndex(pageAndSectionIndex);

    // Get required values
    const patientAgeInDays = this.getPatientAgeInDays(pageIndex);

    // Get claimForValue if not provided
    if (claimForValue === undefined || claimForValue === null) {
      claimForValue = this.getClaimForValueAccommodation(pageAndSectionIndex);
    }

    // Let required validator handle empty values
    if (!claimForValue) {
      return true; // No validation error for empty values
    }

    const claimForValueStr = claimForValue.toString().toLowerCase();
    const patientOnlyId = VPTAS_CLAIM_FOR_IDS.patientOnly.toLowerCase();
    const escortOnlyId = VPTAS_CLAIM_FOR_IDS.escortOnly.toLowerCase();
    const patientAndEscortId = VPTAS_CLAIM_FOR_IDS.patientAndEscort.toLowerCase();
    const allowedPEPEIds = [patientOnlyId, escortOnlyId, patientAndEscortId];

    // Block treatment check: If block treatment is selected, only "Patient Only" is allowed
    if (this.getIsBlockTreatement()) {
      // Return true if "Patient Only" (valid), false otherwise (invalid)
      return (claimForValueStr === patientOnlyId);
    }

    // Get age category
    const ageCategory = this.getAgeCategory(patientAgeInDays);

    // Rule 2: Age < 6 months? → YES → all options allowed (always valid)
    if (ageCategory === VPTAS_AGE_CATEGORIES.infant) {
      return true; // All options allowed, no validation error
    }

    // Rule 3 & 4: Age < 18 years (>= 6 months) OR Age >= 18? → allowed (P/E/PE)
    if (ageCategory === VPTAS_AGE_CATEGORIES.child || ageCategory === VPTAS_AGE_CATEGORIES.adult) {
      // Special rule for children: If treatment is more than 2 consecutive days, support person 2 is allowed
      if (ageCategory === VPTAS_AGE_CATEGORIES.child) {
        const treatmentDuration = this.getTreatmentDurationInDays(pageIndex);
        if (treatmentDuration !== null && treatmentDuration >= 1) {
          // For children with treatment > 1 day, allow support person 2 options
          const patientAndTwoEscortsId = VPTAS_CLAIM_FOR_IDS.patientAndTwoEscorts.toLowerCase();
          const twoEscortsId = VPTAS_CLAIM_FOR_IDS.twoEscorts.toLowerCase();
          const allowedWithSP2 = [...allowedPEPEIds, patientAndTwoEscortsId, twoEscortsId];
          return allowedWithSP2.includes(claimForValueStr);
        }
      }
      // Return true if in allowed list [PatientOnly, EscortOnly, PatientAndEscort] (valid), false otherwise (invalid)
      return allowedPEPEIds.includes(claimForValueStr);
    }

    // Default: If age is unknown, allow all (no validation error)    
    return true;//do not show validation error
  }

  /**
   * Get patient age in days (relative to treatment start date)
   * Returns null if DOB or treatment start date is not available
   */
  private getPatientAgeInDays(pageIndex: number = 0): number | null {
    const formGroup = this.baseForm?.form?.controls?.form as FormGroup;
    if (!formGroup) { return null; }

    const dobControl = formGroup.get(
      `tabs.tab${NAV_TAB_NUMBERS.vptasApplication.applicant}.page${PAGE_NUMBERS.vptasApplicationForm.applicantProfile}.${SECTION_CODES.vptasApplicationForm.profile}.dateOfBirth`
    );

    if (!dobControl?.value) { return null; }

    const dob = this.dateUtil.parseDate(dobControl.value);
    if (!dob) { return null; }

    const treatmentStartDate = this.getTreatmentStartDate(pageIndex);
    if (!treatmentStartDate) { return null; }

    const timeDiff = treatmentStartDate.getTime() - dob.getTime();
    const daysDiff = Math.floor(timeDiff / (1000 * 60 * 60 * 24));

    return daysDiff;
  }

  private getTreatmentStartDate(pageIndex: number = 0): Date | null {
    const formGroup = this.baseForm?.form?.controls?.form as FormGroup;
    if (!formGroup) { return null; }

    const treatmentStartDateControl = formGroup.get(
      `tabs.tab${NAV_TAB_NUMBERS.vptasApplication.travelAndAccommodation}.page${PAGE_NUMBERS.vptasApplicationForm.travelAndAccommodation}.${pageIndex}.${SECTION_CODES.vptasApplicationForm.approvedSpecialistService}.${QUESTION_CODES.vptasApplicationForm.treatmentStartDate}`
    );

    if (!treatmentStartDateControl?.value) { return null; }

    return this.dateUtil.parseDate(treatmentStartDateControl.value);
  }

  private getTreatmentEndDate(pageIndex: number = 0): Date | null {
    const formGroup = this.baseForm?.form?.controls?.form as FormGroup;
    if (!formGroup) { return null; }

    const treatmentEndDateControl = formGroup.get(
      `tabs.tab${NAV_TAB_NUMBERS.vptasApplication.travelAndAccommodation}.page${PAGE_NUMBERS.vptasApplicationForm.travelAndAccommodation}.${pageIndex}.${SECTION_CODES.vptasApplicationForm.approvedSpecialistService}.${QUESTION_CODES.vptasApplicationForm.treatmentEndDate}`
    );

    if (!treatmentEndDateControl?.value) { return null; }

    return this.dateUtil.parseDate(treatmentEndDateControl.value);
  }

  private populateTransportDateFieldsFromTreatment(pageIndex: number): void {
    const transportDetails = this.getTransportDetails(pageIndex) as FormArray;
    if (!transportDetails?.controls?.length) { return; }

    const treatmentStartDate = this.getTreatmentStartDate(pageIndex);
    const treatmentEndDate = this.getTreatmentEndDate(pageIndex);
    if (!treatmentStartDate || !treatmentEndDate) { return; }

    const startDateStr = this.dateUtil.formatToUIDateTimeFormat(treatmentStartDate);
    const endDateStr = this.dateUtil.formatToUIDateTimeFormat(treatmentEndDate);

    // Populate date of travel on first transport item (if empty)
    const firstItem = transportDetails.controls[0]?.value;
    if (firstItem && !firstItem.transportDetailsDateOfTravel) {
      transportDetails.controls[0].patchValue(
        { transportDetailsDateOfTravel: startDateStr },
        { emitEvent: false }
      );
    }

    // Populate date of return on all items (if conditions met)
    const tripType = (firstItem?.transportDetailsTripType ?? '').toString().toLowerCase();
    const isSingleTrip = tripType === VPTAS_TRIP_TYPE_IDS.single?.toString().toLowerCase();
    const isSameDay = (firstItem?.transportDetailsIsReturnOnSameDay === true) 
      || (firstItem?.transportDetailsIsReturnOnSameDay?.toString?.().toLowerCase() === 'true');

    // Populate return date if: NOT single trip AND NOT same day
    if (!isSingleTrip && !isSameDay && tripType !== '') {
      transportDetails.controls.forEach(ctrl => {
        const val = ctrl.value;
        if (val && !val.transportDetailsDateOfReturn) {
          ctrl.patchValue(
            { transportDetailsDateOfReturn: endDateStr },
            { emitEvent: false }
          );
        }
      });
    }
  }

  private populateAccommodationDateFieldsFromTreatment(pageIndex: number): void {
    const accommodationDetails = this.getAccommodationDetails(pageIndex) as FormArray;
    if (!accommodationDetails?.controls?.length) { return; }

    const treatmentStartDate = this.getTreatmentStartDate(pageIndex);
    const treatmentEndDate = this.getTreatmentEndDate(pageIndex);
    if (!treatmentStartDate || !treatmentEndDate) { return; }

    const firstItemControl = accommodationDetails.controls[0];
    const firstItemValue = firstItemControl?.value;
    if (!firstItemValue) { return; }

    const patch: any = {};
    if (!firstItemValue.accommodationDetailsCheckInDate) {
      patch.accommodationDetailsCheckInDate = this.dateUtil.formatToUIDateTimeFormat(treatmentStartDate);
    }
    if (!firstItemValue.accommodationDetailsCheckOutDate) {
      patch.accommodationDetailsCheckOutDate = this.dateUtil.formatToUIDateTimeFormat(treatmentEndDate);
    }

    if (Object.keys(patch).length > 0) {
      firstItemControl.patchValue(patch, { emitEvent: false });
    }
  }

  /**
   * Get treatment duration in days from treatment start date to end date
   * Returns null if dates are not available or invalid
   */
  private getTreatmentDurationInDays(pageIndex: number): number | null {
    const formGroup = this.baseForm?.form?.controls?.form as FormGroup;
    if (!formGroup) { return null; }

    const treatmentStartDateControl = formGroup.get(
      `tabs.tab${NAV_TAB_NUMBERS.vptasApplication.travelAndAccommodation}.page${PAGE_NUMBERS.vptasApplicationForm.travelAndAccommodation}.${pageIndex}.${SECTION_CODES.vptasApplicationForm.approvedSpecialistService}.${QUESTION_CODES.vptasApplicationForm.treatmentStartDate}`
    );

    const treatmentEndDateControl = formGroup.get(
      `tabs.tab${NAV_TAB_NUMBERS.vptasApplication.travelAndAccommodation}.page${PAGE_NUMBERS.vptasApplicationForm.travelAndAccommodation}.${pageIndex}.${SECTION_CODES.vptasApplicationForm.approvedSpecialistService}.${QUESTION_CODES.vptasApplicationForm.treatmentEndDate}`
    );

    if (!treatmentStartDateControl?.value || !treatmentEndDateControl?.value) { return null; }

    const startDate = this.dateUtil.parseDate(treatmentStartDateControl.value);
    const endDate = this.dateUtil.parseDate(treatmentEndDateControl.value);

    if (!startDate || !endDate) { return null; }

    const timeDiff = endDate.getTime() - startDate.getTime();
    const daysDiff = Math.floor(timeDiff / (1000 * 60 * 60 * 24));

    return daysDiff;
  }

  private overrideSummaryAndDocumentListWithCustomComponents() {
    this.formlyConfig.setType([
      {
        name: 'document-list',
        component: VptasDocumentListFieldType
      },
      {
        name: 'summary',
        component: CustomFormSummaryFieldType
      }
    ]);
  }


  private revertBackToDefaultSummaryAndDocumentListComponents() {
    this.formlyConfig.setType([
      {
        name: 'document-list',
        component: DocumentListFieldType
      },
      {
        name: 'summary',
        component: FormSummaryFieldType
      }
    ]);
  }

  private showSpecialistCustomType(pageIndex) {
    return this.getSpecialistType(pageIndex)?.value == EMPTY_GUID;
  }

  private getSpecialistType(pageIndex) {
    return (this.baseForm.form.controls.form as FormGroup).get(`tabs.tab${NAV_TAB_NUMBERS.vptasApplication.travelAndAccommodation}.page${PAGE_NUMBERS.vptasApplicationForm.travelAndAccommodation}.${pageIndex}.${SECTION_CODES.vptasApplicationForm.approvedSpecialistService}.${QUESTION_CODES.vptasApplicationForm.specialistType}`);
  }

  private showSpecialistCustomTypeWarning(pageIndex) {
    return false;
  }

  clone(event: any, formModel: any = null, formControl?: any): void {

    const derivedSectionIndex = formControl?.parent?.index ?? -1;
    const derivedPageIndex = formControl?.parent?.parent?.parent?.index ?? -1;
    const resolvedPageIndex = derivedPageIndex >= 0 ? derivedPageIndex : 0;
    const resolvedSectionIndex = derivedSectionIndex >= 0 ? derivedSectionIndex : 0;
    this.pendingClonePageSectionIndex = this.toPageSectionIndex(resolvedPageIndex, resolvedSectionIndex);
    this.activeDialog = POP_UP_CODES.victorianPatientTransportAssistanceScheme.transportDetailsTripClone;
    this.dialogService.showPopup(this.activeDialog);
  }

  dialogButton_transportDetailsTripClone_Clicked(event: any): void {
    this.spinnerService.showSpinner();

    const pageSectionIndex = this.pendingClonePageSectionIndex ?? [2, 1];
    this.pendingClonePageSectionIndex = null;

    let [pageIndex, sectionIndex] = this.getPageAndSectionIndex(pageSectionIndex);
    if (Number.isNaN(pageIndex) || Number.isNaN(sectionIndex)) {
      this.spinnerService.hideSpinner();
      return;
    }
    this.hideTransportSectionForRemount[pageIndex] = true;
    this.cdr.detectChanges();
    const transportDetails = this.getTransportDetails(pageIndex) as FormArray;
    if (!transportDetails?.controls?.length || sectionIndex < 0 || sectionIndex >= transportDetails.controls.length) {
      this.spinnerService.hideSpinner();
      return;
    }

    // Save previous claimType and set to accommodation temporarily
    const claimTypeControl = this.getClaimTypesControl(pageIndex);
    const previousClaimTypeValue = claimTypeControl?.value;

    if (claimTypeControl) {
      claimTypeControl.patchValue(OPTION_SETS.claimTypes.options.Accommodation, { emitEvent: true });
    }

    const overrides: Record<string, any> = { isEditing: false };
    if (event && typeof event === 'object') {
      const fieldMapping: { [eventKey: string]: string } = {
        transportDetailsTripCloneStartDate: 'transportDetailsDateOfTravel',
        transportDetailsTripCloneEndDate: 'transportDetailsDateOfReturn'
      };
      Object.keys(fieldMapping).forEach(eventKey => {
        const modelKey = fieldMapping[eventKey];
        if (event[eventKey] !== undefined) {
          overrides[modelKey] = _.cloneDeep(event[eventKey]);
        }
      });
    }

    try {
      this.cloneRepeatingSectionItem(
        this.baseForm.model,
        NAV_TAB_NUMBERS.vptasApplication.travelAndAccommodation,
        PAGE_NUMBERS.vptasApplicationForm.travelAndAccommodation,
        pageIndex,
        SECTION_CODES.vptasApplicationForm.transportDetails,
        sectionIndex,
        overrides,
        sectionIndex + 1
      );

      const updatedTransportDetailsModel = this.getTransportDetailsModel(pageIndex);

      // Set isEditing to false for all transport detail items
      if (updatedTransportDetailsModel && Array.isArray(updatedTransportDetailsModel)) {
        updatedTransportDetailsModel.forEach((item: any) => {
          item.isEditing = false;
        });
      }

      this.baseForm.model = { ...this.baseForm.model };
      this.model = { ...this.baseForm.model };

      setTimeout(() => {
        this.hideTransportSectionForRemount[pageIndex] = false;

        // Restore previous claimType value
        if (claimTypeControl && previousClaimTypeValue !== undefined) {
          claimTypeControl.patchValue(previousClaimTypeValue, { emitEvent: true });
        }

        if (claimTypeControl) {
          claimTypeControl.updateValueAndValidity({ emitEvent: true });
        }
        this.cdr.markForCheck();
        this.cdr.detectChanges();
        this.spinnerService.hideSpinner();
      }, 150);
    } catch (error) {
      this.spinnerService.hideSpinner();
      throw error;
    }
  }

  showTransportDetailsCloneButton(pageSectionIndex): boolean {
    const [pageIndex, sectionIndex] = this.getPageAndSectionIndex(pageSectionIndex);

    if (Number.isNaN(pageIndex) || Number.isNaN(sectionIndex)) { return false; }

    const tripType = this.getTransportDetailsTripType(pageIndex, sectionIndex)?.value?.toString()?.toLowerCase();
    const typeOfCarTravel = this.getTransportDetailsTypeOfCarTravel(pageIndex, sectionIndex)?.value?.toString()?.toLowerCase();
    const isMultipleModesSelected = this.isMultipleModesSelected(pageIndex);
    const isReturnTrip = tripType === VPTAS_TRIP_TYPE_IDS.return.toLowerCase();
    const allowedCarTravelTypes = [
      OPTION_SETS.typeOfTravel.options.privateCar.toLowerCase(),
      OPTION_SETS.transportType.options.rentalCar.toLowerCase()
    ];
    const isAllowedCarTravelType = allowedCarTravelTypes.includes(typeOfCarTravel);

    return isReturnTrip && isAllowedCarTravelType && isMultipleModesSelected;
  }

  private getTransportDetailsModel(pageIndex: number): any[] {
    return this.baseForm?.model?.form?.tabs?.[`tab${NAV_TAB_NUMBERS.vptasApplication.travelAndAccommodation}`]?.[`page${PAGE_NUMBERS.vptasApplicationForm.travelAndAccommodation}`]?.[pageIndex]?.[SECTION_CODES.vptasApplicationForm.transportDetails];
  }

  private cloneRepeatingSectionItem(
    response: any,
    tabNumber: number,
    pageNumber: number,
    pageIndex: number,
    sectionCode: string,
    sourceIndex: number,
    overrides: Record<string, any> = {},
    targetIndex?: number
  ): { clonedItem: any; targetIndex: number; modelLength: number } {
    const tabKey = `tab${tabNumber}`;
    const pageKey = `page${pageNumber}`;

    const pages = response?.form?.tabs?.[tabKey]?.[pageKey];

    if (!Array.isArray(pages) || pageIndex < 0 || pageIndex >= pages.length) {
      throw new Error(`Page at index ${pageIndex} does not exist for ${tabKey}/${pageKey}`);
    }

    const page = pages[pageIndex];
    const sectionArray = page?.[sectionCode];

    if (!Array.isArray(sectionArray) || sourceIndex < 0 || sourceIndex >= sectionArray.length) {
      throw new Error(`Source item at index ${sourceIndex} does not exist in section ${sectionCode}`);
    }

    const sourceItem = sectionArray[sourceIndex];

    const clonedItem = _.cloneDeep(sourceItem);
    clonedItem.id = Guid.create().toString();
    clonedItem.$state = 'new';

    Object.keys(overrides).forEach(key => {
      clonedItem[key] = overrides[key];
    });

    const resolvedTargetIndex =
      typeof targetIndex === 'number' && targetIndex >= 0 && targetIndex <= sectionArray.length
        ? targetIndex
        : sectionArray.length;

    sectionArray.splice(resolvedTargetIndex, 0, clonedItem);

    return {
      clonedItem,
      targetIndex: resolvedTargetIndex,
      modelLength: sectionArray.length
    };
  }
  
  private navigateToApplicationDetailPage(ignoreUnsavedChanges = false) {
    this.navigate(['/', ROUTE_CONSTANTS.vptasApplication.prefix, ROUTE_CONSTANTS.vptasApplication.details.prefix, this.id], ignoreUnsavedChanges);
  }

  //Search specialist
  searchSpecialist(event: any, formModel: any = null, formControl?: any) {
    const vptasSpecialistSearchFormRef = this.dynamicDialogService.open(VptasSpecialistSearchFormComponent, {
      header: 'Search Specialist',
      width: '80%',
    });
    vptasSpecialistSearchFormRef.onClose.subscribe((searchResult: any) => {
      if (searchResult?.result === DialogResult.ACCEPTED) {
        const derivedPageIndex = formControl?.parent?.parent?.parent?.index ?? -1;
        const resolvedPageIndex = derivedPageIndex >= 0 ? derivedPageIndex : 0;
        const section = this.getApprovedSpecialistSection(resolvedPageIndex);
        const providerInfo = searchResult.specialistProviderInformation || null;
        const rawManualAddress = providerInfo?.manualAddress;
        const treatmentLocationManualAddress =
          rawManualAddress === true ||
          rawManualAddress === 'true' ||
          rawManualAddress === 1 ||
          rawManualAddress === '1';

        const autoStreetNumberName = treatmentLocationManualAddress
          ? null
          : (providerInfo?.addressAutoStreetNumberName || searchResult.specialistAddressStreetNumberName || null);
        const autoSuburb = treatmentLocationManualAddress
          ? null
          : (providerInfo?.addressAutoSuburb || searchResult.specialistAddressSuburb || null);
        const autoState = treatmentLocationManualAddress
          ? null
          : (providerInfo?.addressAutoState || searchResult.specialistAddressState || null);
        const autoPostCode = treatmentLocationManualAddress
          ? null
          : (providerInfo?.addressAutoPostCode || searchResult.specialistAddressPostCode || null);

        const manualStreetNumberName = treatmentLocationManualAddress
          ? (providerInfo?.AddressManualStreetNumberName || searchResult.specialistAddressStreetNumberName || null)
          : null;
        const manualSuburb = treatmentLocationManualAddress
          ? (providerInfo?.AddressManualSuburb || searchResult.specialistAddressSuburb || null)
          : null;
        const manualState = treatmentLocationManualAddress
          ? (providerInfo?.AddressManualState || searchResult.specialistAddressState || null)
          : null;
        const manualPostCode = treatmentLocationManualAddress
          ? (providerInfo?.AddressManualPostCode || searchResult.specialistAddressPostCode || null)
          : null;

        const treatmentLocation = treatmentLocationManualAddress
          ? null
          : (providerInfo?.addressAuto || searchResult.specialistAddress || null);

        const replacementValues = {
          specialistProviderID: searchResult.specialistProviderNumber || '',
          specialistFirstName: searchResult.specialistFirstName || '',
          specialistMiddleName: searchResult.specialistMiddleName || '',
          specialistName: searchResult.specialistName || '',
          specialistType: searchResult.specialistSpecialty || '',
          [QUESTION_CODES.vptasApplicationForm.approvedSpecialistServiceTreatmentLocationManualAddress]: treatmentLocationManualAddress
        };

        const addressReplacementValues = {
          [QUESTION_CODES.vptasApplicationForm.approvedSpecialistServiceTreatmentLocation]: treatmentLocation,
          [QUESTION_CODES.vptasApplicationForm.approvedSpecialistServiceTreatmentLocationAutoStreetNumberName]: autoStreetNumberName,
          [QUESTION_CODES.vptasApplicationForm.approvedSpecialistServiceTreatmentLocationAutoSuburb]: autoSuburb,
          [QUESTION_CODES.vptasApplicationForm.approvedSpecialistServiceTreatmentLocationAutoState]: autoState,
          [QUESTION_CODES.vptasApplicationForm.approvedSpecialistServiceTreatmentLocationAutoPostCode]: autoPostCode,
          [QUESTION_CODES.vptasApplicationForm.approvedSpecialistServiceTreatmentLocationStreetNumberName]: manualStreetNumberName,
          [QUESTION_CODES.vptasApplicationForm.approvedSpecialistServiceTreatmentLocationSuburb]: manualSuburb,
          [QUESTION_CODES.vptasApplicationForm.approvedSpecialistServiceTreatmentLocationState]: manualState,
          [QUESTION_CODES.vptasApplicationForm.approvedSpecialistServiceTreatmentLocationPostCode]: manualPostCode
        };

        section?.patchValue(replacementValues, { emitEvent: true });
        section?.markAsDirty();

        // Address controls are conditional; retry patching briefly until controls are mounted.
        let attempts = 0;
        const maxAttempts = 5;
        const patchAddressControls = () => {
          if (!section) {
            return;
          }

          let patchedAnyControl = false;
          Object.keys(addressReplacementValues).forEach((key) => {
            const control = section.get(key);
            if (control) {
              control.patchValue(addressReplacementValues[key], { emitEvent: true });
              control.markAsDirty();
              patchedAnyControl = true;
            }
          });

          attempts++;
          if (!patchedAnyControl && attempts < maxAttempts) {
            setTimeout(patchAddressControls, 80);
            return;
          }

          section.updateValueAndValidity({ emitEvent: true });
          this.cdr.detectChanges();
        };

        setTimeout(patchAddressControls, 80);
      }
    });
  }
  //End of Search specialist
}
